import * as yup from 'yup';

export const categoriesSuggestionsSchema = yup.object({
  categories: yup.array(yup.number().required()).required(),
});

export type CategoriesSuggestionsResult = yup.InferType<typeof categoriesSuggestionsSchema>;

export const categoryResultSchema = yup.object({
  id: yup.number().required(),
  state: yup.number().required(),
  label: yup.string().required(),
  alias: yup.string().required(),
  parent: yup.number().nullable().required(),
});

export type CategoryResult = yup.InferType<typeof categoryResultSchema>;

export type NewCategoryMappingKey = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17;

export type NewCategoryMapping = {
  [key in NewCategoryMappingKey]: string;
};

export const newCategoryMapping: NewCategoryMapping = {
  1: 'vetements-chaussures-et-accessoires',
  2: 'meubles',
  3: 'bricolage-outillage-et-materiaux',
  4: 'jardin-et-exterieur',
  5: 'materiel-specialise-et-professionnel',
  6: 'fourniture-de-bureau-et-papeterie',
  7: 'loisirs-et-jeux',
  8: 'livres-audio-films-et-billetterie',
  9: 'high-tech-et-electronique',
  10: 'alimentation',
  11: 'hygiene-soins-et-beaute',
  12: 'animalerie',
  13: 'maison-decoration-et-arts-de-la-table',
  14: 'electromenager',
  15: 'accessoires-de-puericulture',
  16: 'sports-et-activites-de-plein-air',
  17: 'vehicules-pieces-et-accessoires',
};

export type CategoryMappingKey =
  | 'accessoires-de-mode-accessoires-de-mode-28'
  | 'accessoires-de-mode-accessoire-pour-cheveux-accessoires-de-mode-28'
  | 'accessoires-de-mode-accessoires-mode-divers-accessoires-de-mode-28'
  | 'accessoires-de-mode-bretelles-accessoires-de-mode-28'
  | 'accessoires-de-mode-ceinture-accessoires-de-mode-28'
  | 'accessoires-de-mode-chale-et-etole-accessoires-de-mode-28'
  | 'accessoires-de-mode-cravate-et-noeud-papillon-accessoires-de-mode-28'
  | 'accessoires-de-mode-echarpe-et-foulard-accessoires-de-mode-28'
  | 'accessoires-de-mode-etui-telephone-accessoires-de-mode-28'
  | 'accessoires-de-mode-gants-mitaines-et-moufles-accessoires-de-mode-28'
  | 'accessoires-de-mode-housse-de-tablette-et-ordinateur-accessoires-de-mode-28'
  | 'accessoires-de-mode-lunettes-accessoires-de-mode-28'
  | 'accessoires-de-mode-lunettes-de-soleil-accessoires-de-mode-28'
  | 'accessoires-de-mode-montre-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-bague-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-bijou-de-telephone-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-bijou-de-tete-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-boucles-d-oreilles-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-boutons-de-manchette-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-bracelet-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-broche-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-chaine-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-charm-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-chevaliere-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-collier-pendentif-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-gourmette-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-montre-a-gousset-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-montre-automatique-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-montre-bague-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-montre-connectee-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-montre-mecanique-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-montre-pendentif-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-montre-quartz-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-montres-bijoux-divers-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-parure-accessoires-de-mode-28'
  | 'accessoires-de-mode-montres-bijoux-piercing-accessoires-de-mode-28'
  | 'accessoires-de-mode-parapluie-accessoires-de-mode-28'
  | 'accessoires-de-mode-perruque-accessoires-de-mode-28'
  | 'accessoires-de-mode-pochette-accessoires-de-mode-28'
  | 'accessoires-de-mode-porte-cartes-accessoires-de-mode-28'
  | 'accessoires-de-mode-porte-chequier-accessoires-de-mode-28'
  | 'accessoires-de-mode-porte-cles-accessoires-de-mode-28'
  | 'accessoires-de-mode-porte-documents-serviette-accessoires-de-mode-28'
  | 'accessoires-de-mode-porte-monnaie-et-portefeuille-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-cartable-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-mallette-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-sac-a-dos-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-sac-a-main-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-sac-de-sport-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-sac-de-voyage-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-sac-en-bandouliere-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-sacoche-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-tote-bag-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-trousse-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-valise-cabine-accessoires-de-mode-28'
  | 'accessoires-de-mode-sacs-bagages-valise-moyenne-et-grande-taille-accessoires-de-mode-28'
  | 'ameublement-meubles-24'
  | 'ameublement-accessoire-meubles-24'
  | 'ameublement-armoire-meubles-24'
  | 'ameublement-banc-meubles-24'
  | 'ameublement-bar-meubles-24'
  | 'ameublement-bibliotheque-et-etagere-meubles-24'
  | 'ameublement-buffet-meubles-24'
  | 'ameublement-bureau-meubles-24'
  | 'ameublement-cadre-de-lit-meubles-24'
  | 'ameublement-canape-convertible-et-clic-clac-meubles-24'
  | 'ameublement-canape-meubles-24'
  | 'ameublement-chaise-meubles-24'
  | 'ameublement-coffre-et-malle-meubles-24'
  | 'ameublement-coiffeuse-meubles-24'
  | 'ameublement-commode-meubles-24'
  | 'ameublement-console-meubles-24'
  | 'ameublement-douche-baignoire-meubles-24'
  | 'ameublement-dressing-et-penderie-meubles-24'
  | 'ameublement-fauteuil-meubles-24'
  | 'ameublement-lit-meubles-24'
  | 'ameublement-lit-pour-enfant-meubles-24'
  | 'ameublement-luminaire-meubles-24'
  | 'ameublement-luminaire-gande-lampe-meubles-24'
  | 'ameublement-luminaire-lampe-de-bureau-meubles-24'
  | 'ameublement-luminaire-lampe-de-chevet-meubles-24'
  | 'ameublement-matelas-meubles-24'
  | 'ameublement-meuble-de-cuisine-meubles-24'
  | 'ameublement-meuble-de-jardin-balancoire-meubles-24'
  | 'ameublement-meuble-de-jardin-meubles-24'
  | 'ameublement-meuble-de-rangement-meubles-24'
  | 'ameublement-meuble-de-salle-de-bain-meubles-24'
  | 'ameublement-meuble-divers-meubles-24'
  | 'ameublement-meuble-tv-meubles-24'
  | 'ameublement-perforeuse-meubles-24'
  | 'ameublement-porte-manteau-meubles-24'
  | 'ameublement-porte-meubles-24'
  | 'ameublement-sommier-meubles-24'
  | 'ameublement-table-basse-meubles-24'
  | 'ameublement-table-d-appoint-meubles-24'
  | 'ameublement-table-de-chevet-meubles-24'
  | 'ameublement-table-de-salle-a-manger-meubles-24'
  | 'ameublement-table-meubles-24'
  | 'ameublement-tabouret-meubles-24'
  | 'ameublement-tapis-meubles-24'
  | 'ameublement-vaisselier-meubles-24'
  | 'bricolage-jardinage-outillage-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-bricolage-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-ampoules-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-bricolage-divers-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-ferraille-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-huisserie-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-marteau-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-metaux-divers-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-outils-divers-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-peintures-mastic-droguerie-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-perceuse-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-pinceau-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-pistolet-a-etiquette-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-planches-et-bois-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-platre-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-ponceuse-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-roulettes-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-scie-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-scie-circulaire-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-scie-sauteuse-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-tournevis-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-bricolage-visserie-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-jardinage-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-jardinage-brouette-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-jardinage-debroussailleuse-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-jardinage-gants-de-jardinage-bricolage-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-jardinage-graines-et-bulbes-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-jardinage-jardinage-divers-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-jardinage-outils-divers-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-jardinage-pot-de-fleurs-en-plastique-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-jardinage-pot-de-fleurs-en-terre-cuite-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-jardinage-rateau-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-jardinage-secateurs-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-jardinage-terre-jardin-amenagement-exterieur-12'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-cloison-bois-et-panneaux-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-electricite-ventilation-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-equipement-de-protection-securite-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-isolation-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-materiel-de-chantier-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-menuiserie-portes-fenetres-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-plafond-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-plomberie-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-protection-solaire-photovoltaiques-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-quincaillerie-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-revetement-exterieur-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-sol-revetement-carrelage-parement-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-materiaux-de-construction-toiture-couverture-bricolage-construction-et-renovation-6'
  | 'bricolage-jardinage-outillage-outillage-bricolage-construction-et-renovation-6'
  | 'chaussures-chaussures-27'
  | 'chaussures-ballerines-chaussures-27'
  | 'chaussures-baskets-sneakers-chaussures-27'
  | 'chaussures-bottes-chaussures-27'
  | 'chaussures-bottines-lowboots-chaussures-27'
  | 'chaussures-chaussons-pantoufles-chaussures-27'
  | 'chaussures-chaussures-diverses-chaussures-27'
  | 'chaussures-escarpins-chaussures-27'
  | 'chaussures-mocassins-chaussures-27'
  | 'chaussures-sandales-nu-pieds-chaussures-27'
  | 'culture-livres-magazines-15'
  | 'culture-billetterie-loisirs-22'
  | 'culture-cd-dvd-multimedia-high-tech-19'
  | 'culture-culture-divers-loisirs-22'
  | 'culture-livres-livres-magazines-15'
  | 'culture-livres-bande-dessinee-livres-magazines-15'
  | 'culture-livres-fantasy-sf-livres-magazines-15'
  | 'culture-livres-livres-divers-livres-magazines-15'
  | 'culture-livres-manga-livres-magazines-15'
  | 'culture-livres-policier-thriller-livres-magazines-15'
  | 'culture-livres-pour-les-enfants-livres-magazines-15'
  | 'culture-livres-roman-livres-magazines-15'
  | 'culture-livres-sciences-humaines-livres-magazines-15'
  | 'culture-livres-scolaire-soutien-scolaire-livres-magazines-15'
  | 'culture-lot-cd-dvd-livres-multimedia-high-tech-19'
  | 'culture-magazines-livres-magazines-15'
  | 'culture-vinyl-multimedia-high-tech-19'
  | 'emballages'
  | 'emballages-bouteille-flacons-et-bidons-de-produits-menagers-plastique'
  | 'emballages-emballage-divers'
  | 'emballages-emballage-en-papier'
  | 'emballages-emballage-en-polystyrene'
  | 'emballages-emballage-et-produits-en-aluminium'
  | 'emballages-emballage-et-produits-en-carton'
  | 'emballages-emballage-et-produits-en-metal'
  | 'emballages-emballage-et-produits-en-plastique'
  | 'emballages-emballage-et-produits-en-verre-hors-vaisselle'
  | 'emballages-films-sachets-et-barquettes-en-plastique'
  | 'emballages-yaourt-brique-de-lait'
  | 'equipement-bebe-puericulture-20'
  | 'equipement-bebe-babyphone-puericulture-20'
  | 'equipement-bebe-baignoire-puericulture-20'
  | 'equipement-bebe-barriere-de-securite-puericulture-20'
  | 'equipement-bebe-bavoir-puericulture-20'
  | 'equipement-bebe-berceau-puericulture-20'
  | 'equipement-bebe-biberon-puericulture-20'
  | 'equipement-bebe-chaise-haute-puericulture-20'
  | 'equipement-bebe-chanceliere-puericulture-20'
  | 'equipement-bebe-chauffe-biberon-puericulture-20'
  | 'equipement-bebe-combinaison-puericulture-20'
  | 'equipement-bebe-couffin-puericulture-20'
  | 'equipement-bebe-coussin-d-allaitement-puericulture-20'
  | 'equipement-bebe-equipement-bebe-divers-puericulture-20'
  | 'equipement-bebe-gigoteuse-puericulture-20'
  | 'equipement-bebe-humidificateur-puericulture-20'
  | 'equipement-bebe-lit-bebe-puericulture-20'
  | 'equipement-bebe-lit-parapluie-puericulture-20'
  | 'equipement-bebe-matelas-et-matelas-a-langer-puericulture-20'
  | 'equipement-bebe-nacelle-puericulture-20'
  | 'equipement-bebe-parc-puericulture-20'
  | 'equipement-bebe-porte-bebe-et-echarpe-de-portage-puericulture-20'
  | 'equipement-bebe-pot-et-siege-reducteur-puericulture-20'
  | 'equipement-bebe-poubelle-a-couches-puericulture-20'
  | 'equipement-bebe-poussette-puericulture-20'
  | 'equipement-bebe-rehausseur-puericulture-20'
  | 'equipement-bebe-sac-a-langer-puericulture-20'
  | 'equipement-bebe-securite-domestique-puericulture-20'
  | 'equipement-bebe-securite-exterieur-puericulture-20'
  | 'equipement-bebe-siege-auto-puericulture-20'
  | 'equipement-bebe-sterilisateur-puericulture-20'
  | 'equipement-bebe-table-a-langer-puericulture-20'
  | 'equipement-bebe-tapis-d-eveil-puericulture-20'
  | 'equipement-bebe-tetine-puericulture-20'
  | 'equipement-bebe-thermometre-puericulture-20'
  | 'equipement-bebe-tire-lait-puericulture-20'
  | 'equipement-bebe-tour-de-lit-bebe-puericulture-20'
  | 'equipement-bebe-transat-et-balancelle-puericulture-20'
  | 'equipement-bebe-trotteur-puericulture-20'
  | 'equipement-bebe-vaisselle-puericulture-20'
  | 'hygiene-soin-beaute-soins-du-corps-4'
  | 'hygiene-soin-brosse-a-dent-beaute-soins-du-corps-4'
  | 'hygiene-soin-brosse-et-peigne-beaute-soins-du-corps-4'
  | 'hygiene-soin-coloration-cheveux-beaute-soins-du-corps-4'
  | 'hygiene-soin-coton-tiges-beaute-soins-du-corps-4'
  | 'hygiene-soin-couches-bebe-beaute-soins-du-corps-4'
  | 'hygiene-soin-creme-huile-pour-le-corps-beaute-soins-du-corps-4'
  | 'hygiene-soin-deodorant-beaute-soins-du-corps-4'
  | 'hygiene-soin-exfoliant-visage-beaute-soins-du-corps-4'
  | 'hygiene-soin-gel-douche-beaute-soins-du-corps-4'
  | 'hygiene-soin-huile-d-argan-beaute-soins-du-corps-4'
  | 'hygiene-soin-hygiene-soin-divers-beaute-soins-du-corps-4'
  | 'hygiene-soin-lait-pour-le-corps-beaute-soins-du-corps-4'
  | 'hygiene-soin-lingette-beaute-soins-du-corps-4'
  | 'hygiene-soin-maquillage-beaute-soins-du-corps-4'
  | 'hygiene-soin-materiel-medical-beaute-soins-du-corps-4'
  | 'hygiene-soin-pansements-patchs-et-semelles-beaute-soins-du-corps-4'
  | 'hygiene-soin-parfum-beaute-soins-du-corps-4'
  | 'hygiene-soin-rouge-a-levre-beaute-soins-du-corps-4'
  | 'hygiene-soin-savon-beaute-soins-du-corps-4'
  | 'hygiene-soin-shampoing-beaute-soins-du-corps-4'
  | 'hygiene-soin-soin-bebe-beaute-soins-du-corps-4'
  | 'hygiene-soin-vernis-a-ongle-beaute-soins-du-corps-4'
  | 'le-monde-des-animaux-accessoires-et-alimentation-animaux-1'
  | 'le-monde-des-animaux-equipement-chat-accessoires-et-alimentation-animaux-1'
  | 'le-monde-des-animaux-equipement-chien-accessoires-et-alimentation-animaux-1'
  | 'le-monde-des-animaux-le-monde-des-animaux-divers-accessoires-et-alimentation-animaux-1'
  | 'le-monde-des-animaux-nourriture-animaux-accessoires-et-alimentation-animaux-1'
  | 'le-monde-des-animaux-pisciculture-viviculture-accessoires-et-alimentation-animaux-1'
  | 'loisirs-jeux-loisirs-22'
  | 'loisirs-jeux-doudous-et-peluches-jeux-et-jouets-13'
  | 'loisirs-jeux-instruments-de-musique-loisirs-22'
  | 'loisirs-jeux-instruments-de-musique-guitare-acoustique-loisirs-22'
  | 'loisirs-jeux-instruments-de-musique-guitare-electrique-loisirs-22'
  | 'loisirs-jeux-instruments-de-musique-instruments-musique-divers-loisirs-22'
  | 'loisirs-jeux-instruments-de-musique-piano-loisirs-22'
  | 'loisirs-jeux-instruments-de-musique-ukulele-loisirs-22'
  | 'loisirs-jeux-jouets-jeux-et-jouets-13'
  | 'loisirs-jeux-jouets-cuisines-et-dinettes-jeux-et-jouets-13'
  | 'loisirs-jeux-jouets-jeux-de-construction-jeux-et-jouets-13'
  | 'loisirs-jeux-jouets-jeux-de-societe-puzzle-jeux-et-jouets-13'
  | 'loisirs-jeux-jouets-jeux-educatifs-jeux-et-jouets-13'
  | 'loisirs-jeux-jouets-jeux-radiocommandes-jeux-et-jouets-13'
  | 'loisirs-jeux-jouets-jouet-divers-jeux-et-jouets-13'
  | 'loisirs-jeux-jouets-jouets-d-eveil-jeux-et-jouets-13'
  | 'loisirs-jeux-jouets-porteurs-trotteurs-et-draisiennes-jeux-et-jouets-13'
  | 'loisirs-jeux-jouets-poupees-et-accessoires-jeux-et-jouets-13'
  | 'loisirs-jeux-jouets-trains-bateaux-et-avions-jeux-et-jouets-13'
  | 'loisirs-jeux-jouets-voitures-et-circuits-jeux-et-jouets-13'
  | 'loisirs-jeux-loisirs-creatifs-loisirs-22'
  | 'loisirs-jeux-loisirs-creatifs-adhesifs-loisirs-22'
  | 'loisirs-jeux-loisirs-creatifs-chutes-de-tissu-loisirs-22'
  | 'loisirs-jeux-loisirs-creatifs-colle-loisirs-22'
  | 'loisirs-jeux-loisirs-creatifs-loisirs-creatifs-divers-loisirs-22'
  | 'loisirs-jeux-loisirs-creatifs-noeuds-loisirs-22'
  | 'loisirs-jeux-loisirs-creatifs-papeterie-carnet-loisirs-22'
  | 'loisirs-jeux-loisirs-creatifs-pate-a-modeler-loisirs-22'
  | 'loisirs-jeux-loisirs-creatifs-pate-fimo-loisirs-22'
  | 'loisirs-jeux-loisirs-creatifs-peinture-loisirs-22'
  | 'loisirs-jeux-loisirs-creatifs-perles-pendentifs-loisirs-22'
  | 'loisirs-jeux-loisirs-creatifs-rubans-loisirs-22'
  | 'loisirs-jeux-loisirs-creatifs-tableau-cadre-loisirs-22'
  | 'loisirs-jeux-objets-de-collection-cartes-et-vignette-collection-7'
  | 'loisirs-jeux-objets-de-collection-collection-7'
  | 'loisirs-jeux-objets-de-collection-objet-de-collection-divers-collection-7'
  | 'loisirs-jeux-objets-de-collection-timbres-collection-7'
  | 'loisirs-jeux-plein-air-barbecue-mobile-loisirs-22'
  | 'loisirs-jeux-plein-air-bouee-de-piscine-loisirs-22'
  | 'loisirs-jeux-plein-air-canne-a-peche-loisirs-22'
  | 'loisirs-jeux-plein-air-filet-de-peche-loisirs-22'
  | 'loisirs-jeux-plein-air-loisirs-22'
  | 'loisirs-jeux-plein-air-matelas-de-camping-loisirs-22'
  | 'loisirs-jeux-plein-air-panier-de-peche-loisirs-22'
  | 'loisirs-jeux-plein-air-parasol-loisirs-22'
  | 'loisirs-jeux-plein-air-plein-air-divers-loisirs-22'
  | 'loisirs-jeux-plein-air-rechaud-loisirs-22'
  | 'loisirs-jeux-plein-air-sac-de-couchage-loisirs-22'
  | 'loisirs-jeux-plein-air-serviette-de-plage-loisirs-22'
  | 'loisirs-jeux-plein-air-tente-de-camping-loisirs-22'
  | 'loisirs-jeux-plein-air-transat-loisirs-22'
  | 'maison-arts-de-la-table-arts-de-la-table-divers-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-assiette-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-beurrier-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-bocaux-et-pots-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-boite-de-conservation-et-boite-en-metal-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-bol-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-bonbonniere-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-carafe-et-pichet-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-casserole-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-casseroles-en-fonte-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-cocotte-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-coffret-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-coquetier-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-corbeille-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-coupe-et-coupelle-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-couteaux-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-couvercle-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-couvert-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-dessous-de-plat-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-flute-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-gourde-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-huilier-et-vinaigrier-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-mazagran-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-moule-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-planche-a-decouper-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-plat-a-four-et-a-tarte-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-plat-aperitif-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-plat-de-service-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-plateau-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-poele-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-ramequin-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-rond-de-serviette-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-saladier-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-saliere-poivriere-et-sucrier-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-sauciere-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-seau-a-glacons-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-service-a-cafe-ou-a-the-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-service-de-vaisselle-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-set-de-table-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-shaker-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-soucoupe-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-soupiere-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-sous-verre-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-tasse-et-mug-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-terrine-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-theiere-tisaniere-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-tire-bouchon-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-torchon-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-ustensile-de-cuisine-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-verre-cuisine-et-arts-la-table-2'
  | 'maison-arts-de-la-table-verrine-cuisine-et-arts-la-table-2'
  | 'maison-decoration-abat-jour-decoration-25'
  | 'maison-decoration-accessoire-de-rangement-decoration-25'
  | 'maison-decoration-accessoire-de-salle-de-bain-decoration-25'
  | 'maison-decoration-applique-decoration-25'
  | 'maison-decoration-bibelot-decoration-25'
  | 'maison-decoration-bougie-et-photophore-decoration-25'
  | 'maison-decoration-bouquet-et-plante-artificielle-decoration-25'
  | 'maison-decoration-cadre-photo-decoration-25'
  | 'maison-decoration-cendrier-et-vide-poche-decoration-25'
  | 'maison-decoration-coussin-decoration-25'
  | 'maison-decoration-dame-jeanne-et-bonbonne-decoration-25'
  | 'maison-decoration-decoration-25'
  | 'maison-decoration-decoration-diverse-decoration-25'
  | 'maison-decoration-guirlande-decoration-25'
  | 'maison-decoration-horloge-pendule-et-reveil-decoration-25'
  | 'maison-decoration-lustre-decoration-25'
  | 'maison-decoration-miroir-decoration-25'
  | 'maison-decoration-panier-boite-tupperware-decoration-25'
  | 'maison-decoration-papier-peint-decoration-25'
  | 'maison-decoration-paravent-decoration-25'
  | 'maison-decoration-pele-mele-photo-decoration-25'
  | 'maison-decoration-pelotte-de-laine-decoration-25'
  | 'maison-decoration-plante-decoration-25'
  | 'maison-decoration-rideaux-voilage-et-store-decoration-25'
  | 'maison-decoration-sculpture-et-statue-decoration-25'
  | 'maison-decoration-tableau-et-toile-decoration-25'
  | 'maison-decoration-tapis-decoration-25'
  | 'maison-decoration-vase-cache-pot-et-ceramique-decoration-25'
  | 'maison-entretien-nettoyage-balai-entretien-de-la-maison-accessoires-et-produits-10'
  | 'maison-entretien-nettoyage-entretien-de-la-maison-accessoires-et-produits-10'
  | 'maison-entretien-nettoyage-eponge-entretien-de-la-maison-accessoires-et-produits-10'
  | 'maison-entretien-nettoyage-javel-entretien-de-la-maison-accessoires-et-produits-10'
  | 'maison-entretien-nettoyage-lessive-entretien-de-la-maison-accessoires-et-produits-10'
  | 'maison-entretien-nettoyage-liquide-vaisselle-entretien-de-la-maison-accessoires-et-produits-10'
  | 'maison-entretien-nettoyage-pastilles-de-lave-vaisselle-entretien-de-la-maison-accessoires-et-produits-10'
  | 'maison-gros-electromenager-appareil-de-cuisson-electromenager-9'
  | 'maison-gros-electromenager-cave-a-vin-electromenager-9'
  | 'maison-gros-electromenager-climatiseur-electromenager-9'
  | 'maison-gros-electromenager-congelateur-electromenager-9'
  | 'maison-gros-electromenager-cuisiniere-electromenager-9'
  | 'maison-gros-electromenager-electromenager-9'
  | 'maison-gros-electromenager-four-electromenager-9'
  | 'maison-gros-electromenager-four-professionnel-electromenager-9'
  | 'maison-gros-electromenager-frigo-americain-electromenager-9'
  | 'maison-gros-electromenager-frigo-electromenager-9'
  | 'maison-gros-electromenager-gaziniere-electromenager-9'
  | 'maison-gros-electromenager-gros-electromenager-divers-electromenager-9'
  | 'maison-gros-electromenager-hotte-electromenager-9'
  | 'maison-gros-electromenager-lave-linge-electromenager-9'
  | 'maison-gros-electromenager-lave-vaisselle-electromenager-9'
  | 'maison-gros-electromenager-machine-a-laver-electromenager-9'
  | 'maison-gros-electromenager-piano-de-cuisson-electromenager-9'
  | 'maison-gros-electromenager-plaque-de-cuisson-electromenager-9'
  | 'maison-gros-electromenager-refrigerateur-electromenager-9'
  | 'maison-gros-electromenager-seche-linge-electromenager-9'
  | 'maison-linge-de-maison-deco-textile-linge-de-maison-14'
  | 'maison-linge-de-maison-draps-linge-de-maison-14'
  | 'maison-linge-de-maison-linge-de-bain-linge-de-maison-14'
  | 'maison-linge-de-maison-linge-de-lit-linge-de-maison-14'
  | 'maison-linge-de-maison-linge-de-maison-14'
  | 'maison-linge-de-maison-linge-de-maison-divers-linge-de-maison-14'
  | 'maison-linge-de-maison-linge-de-table-linge-de-maison-14'
  | 'maison-meubles-24'
  | 'maison-petit-electromenager-appareil-de-massage-electromenager-9'
  | 'maison-petit-electromenager-aspirateur-electromenager-9'
  | 'maison-petit-electromenager-autres-robots-electromenager-9'
  | 'maison-petit-electromenager-balance-de-cuisine-electromenager-9'
  | 'maison-petit-electromenager-barbecue-et-plancha-electrique-electromenager-9'
  | 'maison-petit-electromenager-batterie-externe-electromenager-9'
  | 'maison-petit-electromenager-bouilloire-electromenager-9'
  | 'maison-petit-electromenager-brosse-a-dent-electrique-electromenager-9'
  | 'maison-petit-electromenager-brosse-coiffante-electromenager-9'
  | 'maison-petit-electromenager-centre-de-repassage-electromenager-9'
  | 'maison-petit-electromenager-chauffage-d-appoint-electromenager-9'
  | 'maison-petit-electromenager-defroisseur-electromenager-9'
  | 'maison-petit-electromenager-electromenager-9'
  | 'maison-petit-electromenager-epilateur-electromenager-9'
  | 'maison-petit-electromenager-extracteur-de-jus-electromenager-9'
  | 'maison-petit-electromenager-fer-a-boucler-electromenager-9'
  | 'maison-petit-electromenager-fer-a-repasser-electromenager-9'
  | 'maison-petit-electromenager-four-a-micro-ondes-electromenager-9'
  | 'maison-petit-electromenager-grille-pain-electromenager-9'
  | 'maison-petit-electromenager-lisseur-electromenager-9'
  | 'maison-petit-electromenager-machine-a-cafe-electromenager-9'
  | 'maison-petit-electromenager-machine-a-coudre-electromenager-9'
  | 'maison-petit-electromenager-machine-a-pain-electromenager-9'
  | 'maison-petit-electromenager-machine-a-soda-electromenager-9'
  | 'maison-petit-electromenager-machine-a-the-electromenager-9'
  | 'maison-petit-electromenager-mini-four-electrique-electromenager-9'
  | 'maison-petit-electromenager-mixeur-electromenager-9'
  | 'maison-petit-electromenager-nettoyeur-vapeur-electromenager-9'
  | 'maison-petit-electromenager-pese-personne-electromenager-9'
  | 'maison-petit-electromenager-petit-electromenager-divers-electromenager-9'
  | 'maison-petit-electromenager-rasoir-electrique-electromenager-9'
  | 'maison-petit-electromenager-reveil-electromenager-9'
  | 'maison-petit-electromenager-robot-cuiseur-electromenager-9'
  | 'maison-petit-electromenager-robot-multifonction-electromenager-9'
  | 'maison-petit-electromenager-robot-patissier-electromenager-9'
  | 'maison-petit-electromenager-seche-cheveux-electromenager-9'
  | 'maison-petit-electromenager-sorbetiere-electromenager-9'
  | 'maison-petit-electromenager-tireuse-a-biere-electromenager-9'
  | 'maison-petit-electromenager-tondeuse-electromenager-9'
  | 'maison-petit-electromenager-ventilateur-electromenager-9'
  | 'maison-petit-electromenager-yaourtiere-electromenager-9'
  | 'maison-rangements-et-organisation-boites-decoration-25'
  | 'maison-rangements-et-organisation-cartons-decoration-25'
  | 'maison-rangements-et-organisation-decoration-25'
  | 'maison-rangements-et-organisation-rangement-et-organisation-divers-decoration-25'
  | 'materiel-professionnel-btp-gros-oeuvre-materiel-specialise-17'
  | 'materiel-professionnel-fournitures-de-bureau-fournitures-de-bureau-divers-materiel-de-bureau-scolaire-16'
  | 'materiel-professionnel-fournitures-de-bureau-materiel-de-bureau-scolaire-16'
  | 'materiel-professionnel-fournitures-de-bureau-stylo-et-crayons-materiel-de-bureau-scolaire-16'
  | 'materiel-professionnel-materiel-medical-materiel-specialise-17'
  | 'materiel-professionnel-materiel-professionnel-divers-materiel-specialise-17'
  | 'materiel-professionnel-materiel-specialise-17'
  | 'multimedia-cables-connectique-multimedia-high-tech-19'
  | 'multimedia-calculatrice-multimedia-high-tech-19'
  | 'multimedia-consoles-jeux-video-console-de-salon-multimedia-high-tech-19'
  | 'multimedia-consoles-jeux-video-console-portable-multimedia-high-tech-19'
  | 'multimedia-consoles-jeux-video-consoles-jeux-video-divers-multimedia-high-tech-19'
  | 'multimedia-consoles-jeux-video-jeux-video-multimedia-high-tech-19'
  | 'multimedia-consoles-jeux-video-multimedia-high-tech-19'
  | 'multimedia-decodeur-multimedia-high-tech-19'
  | 'multimedia-image-son-appareil-photo-multimedia-high-tech-19'
  | 'multimedia-image-son-baladeurs-numeriques-multimedia-high-tech-19'
  | 'multimedia-image-son-barre-de-son-multimedia-high-tech-19'
  | 'multimedia-image-son-cadre-photo-numerique-multimedia-high-tech-19'
  | 'multimedia-image-son-casque-audio-multimedia-high-tech-19'
  | 'multimedia-image-son-enceinte-bluetooth-multimedia-high-tech-19'
  | 'multimedia-image-son-home-cinema-multimedia-high-tech-19'
  | 'multimedia-image-son-image-son-divers-multimedia-high-tech-19'
  | 'multimedia-image-son-lecteur-dvd-multimedia-high-tech-19'
  | 'multimedia-image-son-liseuse-multimedia-high-tech-19'
  | 'multimedia-image-son-multimedia-high-tech-19'
  | 'multimedia-image-son-telecommande-multimedia-high-tech-19'
  | 'multimedia-image-son-television-multimedia-high-tech-19'
  | 'multimedia-image-son-video-projecteur-multimedia-high-tech-19'
  | 'multimedia-informatique-baies-de-disques-multimedia-high-tech-19'
  | 'multimedia-informatique-cartouche-d-encre-multimedia-high-tech-19'
  | 'multimedia-informatique-clavier-multimedia-high-tech-19'
  | 'multimedia-informatique-ecran-d-ordinateur-multimedia-high-tech-19'
  | 'multimedia-informatique-imprimante-laser-multimedia-high-tech-19'
  | 'multimedia-informatique-imprimante-multimedia-high-tech-19'
  | 'multimedia-informatique-informatique-divers-multimedia-high-tech-19'
  | 'multimedia-informatique-modem-multimedia-high-tech-19'
  | 'multimedia-informatique-multimedia-high-tech-19'
  | 'multimedia-informatique-ordinateur-fixe-multimedia-high-tech-19'
  | 'multimedia-informatique-ordinateur-portable-multimedia-high-tech-19'
  | 'multimedia-informatique-souris-multimedia-high-tech-19'
  | 'multimedia-informatique-webcam-multimedia-high-tech-19'
  | 'multimedia-multimedia-high-tech-19'
  | 'multimedia-outils-divers-multimedia-high-tech-19'
  | 'multimedia-photocopieurs-multimedia-high-tech-19'
  | 'multimedia-radio-multimedia-high-tech-19'
  | 'multimedia-tablette-multimedia-high-tech-19'
  | 'multimedia-telephonie-batterie-de-telephone-multimedia-high-tech-19'
  | 'multimedia-telephonie-multimedia-high-tech-19'
  | 'multimedia-telephonie-telephone-fixe-multimedia-high-tech-19'
  | 'multimedia-telephonie-telephone-portable-smartphone-multimedia-high-tech-19'
  | 'multimedia-telephonie-telephonie-divers-multimedia-high-tech-19'
  | 'nourriture-alimentaire-29'
  | 'nourriture-conserve-alimentaire-29'
  | 'nourriture-epicerie-salee-alimentaire-29'
  | 'nourriture-epicerie-sucree-alimentaire-29'
  | 'sport-basket-ball-ballon-sport-21'
  | 'sport-basket-ball-basket-ball-divers-sport-21'
  | 'sport-basket-ball-panier-exterieur-avec-socle-sport-21'
  | 'sport-basket-ball-panier-interieur-fixe-avec-socle-sport-21'
  | 'sport-basket-ball-sport-21'
  | 'sport-cyclisme-accessoire-velo-sport-21'
  | 'sport-cyclisme-chambre-a-air-sport-21'
  | 'sport-cyclisme-cyclisme-divers-sport-21'
  | 'sport-cyclisme-piece-de-velo-sport-21'
  | 'sport-cyclisme-pneu-sport-21'
  | 'sport-cyclisme-sport-21'
  | 'sport-cyclisme-velo-d-appartement-sport-21'
  | 'sport-cyclisme-velo-de-course-sport-21'
  | 'sport-cyclisme-velo-de-ville-vtc-sport-21'
  | 'sport-cyclisme-velo-electrique-sport-21'
  | 'sport-cyclisme-velo-enfant-sport-21'
  | 'sport-cyclisme-vtt-sport-21'
  | 'sport-divers-paire-de-rollers-sport-21'
  | 'sport-divers-skateboard-sport-21'
  | 'sport-divers-sport-21'
  | 'sport-divers-trampoline-sport-21'
  | 'sport-divers-trotinette-sport-21'
  | 'sport-equitation-bombe-sport-21'
  | 'sport-equitation-cravache-sport-21'
  | 'sport-equitation-equitation-divers-sport-21'
  | 'sport-equitation-harnais-sport-21'
  | 'sport-equitation-selle-sport-21'
  | 'sport-equitation-sport-21'
  | 'sport-escrime-epee-sport-21'
  | 'sport-escrime-fleuret-sport-21'
  | 'sport-escrime-masque-sport-21'
  | 'sport-escrime-sabre-sport-21'
  | 'sport-escrime-sport-21'
  | 'sport-football-ballon-sport-21'
  | 'sport-football-cage-de-foot-sport-21'
  | 'sport-football-football-divers-sport-21'
  | 'sport-football-protege-tibia-sport-21'
  | 'sport-football-sport-21'
  | 'sport-golf-balle-sport-21'
  | 'sport-golf-club-sport-21'
  | 'sport-golf-golf-divers-sport-21'
  | 'sport-golf-sport-21'
  | 'sport-gymnastique-agres-barre-fixe-sport-21'
  | 'sport-gymnastique-agres-barres-assymetriques-sport-21'
  | 'sport-gymnastique-agres-barres-paralleles-sport-21'
  | 'sport-gymnastique-gymnastique-divers-sport-21'
  | 'sport-gymnastique-sport-21'
  | 'sport-gymnastique-tatami-sport-21'
  | 'sport-handball-ballon-sport-21'
  | 'sport-handball-handball-divers-sport-21'
  | 'sport-handball-sport-21'
  | 'sport-judo-ceinture-d-art-martial-sport-21'
  | 'sport-judo-judo-divers-sport-21'
  | 'sport-judo-kimono-sport-21'
  | 'sport-judo-sport-21'
  | 'sport-judo-tatami-sport-21'
  | 'sport-materiel-de-chasse-sport-21'
  | 'sport-musculation-et-fitness-sport-21'
  | 'sport-natation-lunettes-de-natation-sport-21'
  | 'sport-natation-maillot-sport-21'
  | 'sport-natation-masque-sport-21'
  | 'sport-natation-natation-divers-sport-21'
  | 'sport-natation-pince-nez-sport-21'
  | 'sport-natation-sport-21'
  | 'sport-natation-tuba-sport-21'
  | 'sport-plongee-bouteille-sport-21'
  | 'sport-plongee-masque-sport-21'
  | 'sport-plongee-plongee-divers-sport-21'
  | 'sport-plongee-sport-21'
  | 'sport-plongee-tuba-sport-21'
  | 'sport-randonnee-batons-de-marche-sport-21'
  | 'sport-randonnee-randonnee-divers-sport-21'
  | 'sport-randonnee-sac-a-dos-de-randonnee-sport-21'
  | 'sport-randonnee-sport-21'
  | 'sport-randonnee-tente-sport-21'
  | 'sport-sport-21'
  | 'sport-sport-d-hiver-batons-de-ski-sport-21'
  | 'sport-sport-d-hiver-casque-de-ski-sport-21'
  | 'sport-sport-d-hiver-paire-de-skis-sport-21'
  | 'sport-sport-d-hiver-snowboard-sport-21'
  | 'sport-sport-d-hiver-sport-21'
  | 'sport-sport-d-hiver-sport-d-hiver-divers-sport-21'
  | 'sport-sport-de-combat-gants-de-boxe-sport-21'
  | 'sport-sport-de-combat-sac-de-frappe-sport-21'
  | 'sport-sport-de-combat-sport-21'
  | 'sport-sport-de-combat-sport-de-combat-divers-sport-21'
  | 'sport-sport-nautique-planche-a-voile-sport-21'
  | 'sport-sport-nautique-planche-de-surf-sport-21'
  | 'sport-sport-nautique-sport-21'
  | 'sport-sport-nautique-sport-nautique-divers-sport-21'
  | 'sport-sport-nautique-voile-sport-21'
  | 'sport-tennis-balle-sport-21'
  | 'sport-tennis-raquette-sport-21'
  | 'sport-tennis-sport-21'
  | 'sport-tennis-tennis-divers-sport-21'
  | 'sport-volleyball-ballon-sport-21'
  | 'sport-volleyball-sport-21'
  | 'sport-volleyball-volleyball-divers-sport-21'
  | 'sport-yoga-sport-21'
  | 'sport-yoga-tapis-de-yoga-sport-21'
  | 'sport-yoga-yoga-divers-sport-21'
  | 'vehicule-auto-moto-vehicules-3'
  | 'vehicule-caravaning-auto-moto-vehicules-3'
  | 'vehicule-equipement-auto-auto-moto-vehicules-3'
  | 'vehicule-equipement-caravaning-auto-moto-vehicules-3'
  | 'vehicule-equipement-moto-auto-moto-vehicules-3'
  | 'vehicule-equipement-nautisme-auto-moto-vehicules-3'
  | 'vehicule-equipement-utilitaires-auto-moto-vehicules-3'
  | 'vehicule-motos-auto-moto-vehicules-3'
  | 'vehicule-nautisme-auto-moto-vehicules-3'
  | 'vehicule-pneumatique-moto-auto-moto-vehicules-3'
  | 'vehicule-pneumatique-voiture-auto-moto-vehicules-3'
  | 'vehicule-utilitaire-auto-moto-vehicules-3'
  | 'vehicule-vehicule-divers-auto-moto-vehicules-3'
  | 'vehicule-voitures-auto-moto-vehicules-3'
  | 'vetements-bodies-bebe-vetements-26'
  | 'vetements-bonnets-chapeaux-bonnet-vetements-26'
  | 'vetements-bonnets-chapeaux-casquette-vetements-26'
  | 'vetements-bonnets-chapeaux-chapeau-vetements-26'
  | 'vetements-bonnets-chapeaux-vetements-26'
  | 'vetements-chemises-chemisiers-vetements-26'
  | 'vetements-costumes-tailleurs-vetements-26'
  | 'vetements-deguisement-vetements-26'
  | 'vetements-ensembles-combinaisons-vetements-26'
  | 'vetements-hauts-t-shirts-vetements-26'
  | 'vetements-jeans-vetements-26'
  | 'vetements-jupe-vetements-26'
  | 'vetements-lot-de-vetements-vetements-26'
  | 'vetements-maillots-de-bain-vetements-de-plage-vetements-26'
  | 'vetements-manteaux-vestes-vetements-26'
  | 'vetements-mariage-vetements-26'
  | 'vetements-pantalons-vetements-26'
  | 'vetements-polaire-vetements-26'
  | 'vetements-polo-vetements-26'
  | 'vetements-pulls-gilets-vetements-26'
  | 'vetements-pyjamas-vetements-de-nuit-vetements-26'
  | 'vetements-robes-jupes-vetements-26'
  | 'vetements-shorts-pantacourts-bermudas-vetements-26'
  | 'vetements-sous-vetements-calecon-vetements-26'
  | 'vetements-sous-vetements-culotte-vetements-26'
  | 'vetements-sous-vetements-ensemble-lingerie-vetements-26'
  | 'vetements-sous-vetements-slip-vetements-26'
  | 'vetements-sous-vetements-soutiens-gorge-vetements-26'
  | 'vetements-sous-vetements-vetements-26'
  | 'vetements-sweat-vetements-26'
  | 'vetements-vetement-divers-vetements-26'
  | 'vetements-vetements-26'
  | 'vetements-vetements-equipements-de-sport-vetements-26'
  | 'bouchons'
  | 'bouchons-bouchon-en-liege'
  | 'bouchons-bouchon-en-plastique'
  | 'bouchons-bouchons-divers'
  | 'categorisation-en-cours'
  | 'dechets-alimentaires'
  | 'dechets-alimentaires-cafe'
  | 'dechets-alimentaires-capsule-cafe'
  | 'dechets-alimentaires-dechet-alimentaire-divers'
  | 'dechets-alimentaires-epluchures-fruits-et-legumes'
  | 'dechets-alimentaires-huile-de-friture'
  | 'dechets-alimentaires-reste-de-repas'
  | 'dechets-construction-bricolage'
  | 'dechets-construction-bricolage-ampoules-ou-neons-usages'
  | 'dechets-construction-bricolage-dechets-construction-divers'
  | 'dechets-construction-bricolage-dechets-textiles'
  | 'dechets-construction-bricolage-ferraille'
  | 'dechets-construction-bricolage-gravats-et-deblais'
  | 'dechets-construction-bricolage-huisserie'
  | 'dechets-construction-bricolage-metaux-non-ferreux'
  | 'dechets-construction-bricolage-planches-et-bois'
  | 'dechets-construction-bricolage-platre'
  | 'dechets-dangereux'
  | 'dechets-dangereux-allume-feu'
  | 'dechets-dangereux-batterie-accumulateurs'
  | 'dechets-dangereux-bouteilles-et-cartouches-de-gaz-usagees'
  | 'dechets-dangereux-colles-pour-sol-et-mur-usagees'
  | 'dechets-dangereux-extincteurs-usages'
  | 'dechets-dangereux-huile-usees-vidange'
  | 'dechets-dangereux-materiaux-explosifs'
  | 'dechets-dangereux-peintures-et-vernis-usages'
  | 'dechets-dangereux-piles-usagees'
  | 'dechets-dangereux-produits-amiantiferes-toles-fibro-ciment'
  | 'dechets-dangereux-produits-nettoyants-detergents-desinfectants'
  | 'dechets-dangereux-produits-phytosanitaires-insecticides-herbicides-acaricides'
  | 'dechets-dangereux-produits-radioactifs'
  | 'dechets-dangereux-reste-d-engrais'
  | 'dechets-dangereux-solvants-decapants-alcools-cetones-ethers-esters'
  | 'dechets-en-verre'
  | 'dechets-en-verre-bouteille-bocaux-flacons-pots-verre'
  | 'dechets-menagers'
  | 'dechets-menagers-articles-d-hygiene-couches-lingettes-mouchoirs'
  | 'dechets-menagers-petits-objets-casses-non-electriques'
  | 'dechets-menagers-vaisselle-et-assiettes-cassees'
  | 'dechets-menagers-vaisselle-jetable'
  | 'dechets-papier'
  | 'dechets-papier-catalogue'
  | 'dechets-papier-enveloppes'
  | 'dechets-papier-feuilles-dessin-cahier'
  | 'dechets-papier-journaux-magazines'
  | 'dechets-papier-livres-abimes'
  | 'dechets-papier-papier-cadeau'
  | 'dechets-papier-tickets-de-caisse'
  | 'dechets-verts'
  | 'dechets-verts-branchage-et-bois'
  | 'dechets-verts-dechets-papier-divers'
  | 'dechets-verts-dechets-verts-divers'
  | 'dechets-verts-feuilles'
  | 'dechets-verts-taille'
  | 'dechets-verts-terre'
  | 'dechets-verts-tonte-de-pelouse'
  | 'produits-medicaux'
  | 'produits-medicaux-dechets-infectieux-des-soins-medicaux-ou-veterinaires'
  | 'produits-medicaux-emballages-de-medicaments'
  | 'produits-medicaux-produits-medicaux-divers'
  | 'produits-medicaux-reste-de-medicaments'
  | 'produits-medicaux-seringues-usagees'
  | 'loisirs-et-jeux'
  | 'maison-decoration-et-arts-de-la-table'
  | 'materiel-specialise-et-professionnel'
  | 'meubles'
  | 'sports-et-activites-de-plein-air'
  | 'vehicules-pieces-et-accessoires'
  | 'vetements-chaussures-et-accessoires'
  | 'accessoires-de-puericulture'
  | 'alimentation'
  | 'animalerie'
  | 'bricolage-outillage-et-materiaux'
  | 'electromenager'
  | 'fourniture-de-bureau-et-papeterie'
  | 'high-tech-et-electronique'
  | 'jardin-et-exterieur'
  | 'hygiene-soins-et-beaute'
  | 'livres-audio-films-et-billetterie';

type CategoryMapping = {
  [key in CategoryMappingKey]: string | number;
};

export const categoryMapping: CategoryMapping = {
  'accessoires-de-mode-accessoires-de-mode-28': 'Accessoires de mode',
  'accessoires-de-mode-accessoire-pour-cheveux-accessoires-de-mode-28': 'Accessoire pour cheveux',
  'accessoires-de-mode-accessoires-mode-divers-accessoires-de-mode-28': 'Accessoires Mode divers',
  'accessoires-de-mode-bretelles-accessoires-de-mode-28': 'Bretelles',
  'accessoires-de-mode-ceinture-accessoires-de-mode-28': 'Ceinture',
  'accessoires-de-mode-chale-et-etole-accessoires-de-mode-28': 'Châle et étole',
  'accessoires-de-mode-cravate-et-noeud-papillon-accessoires-de-mode-28': 'Cravate et noeud papillon',
  'accessoires-de-mode-echarpe-et-foulard-accessoires-de-mode-28': 'Echarpe et foulard',
  'accessoires-de-mode-etui-telephone-accessoires-de-mode-28': 'Etui téléphone',
  'accessoires-de-mode-gants-mitaines-et-moufles-accessoires-de-mode-28': 'Gants, mitaines et moufles',
  'accessoires-de-mode-housse-de-tablette-et-ordinateur-accessoires-de-mode-28': 'Housse de tablette et ordinateur',
  'accessoires-de-mode-lunettes-accessoires-de-mode-28': 'Lunettes',
  'accessoires-de-mode-lunettes-de-soleil-accessoires-de-mode-28': 'Lunettes de soleil',
  'accessoires-de-mode-montre-accessoires-de-mode-28': 'Montre',
  'accessoires-de-mode-montres-bijoux-accessoires-de-mode-28': 'Montres & bijoux',
  'accessoires-de-mode-montres-bijoux-bague-accessoires-de-mode-28': 'Bague',
  'accessoires-de-mode-montres-bijoux-bijou-de-telephone-accessoires-de-mode-28': 'Bijou de téléphone',
  'accessoires-de-mode-montres-bijoux-bijou-de-tete-accessoires-de-mode-28': 'Bijou de tête',
  'accessoires-de-mode-montres-bijoux-boucles-d-oreilles-accessoires-de-mode-28': "Boucles d'oreilles",
  'accessoires-de-mode-montres-bijoux-boutons-de-manchette-accessoires-de-mode-28': 'Boutons de manchette',
  'accessoires-de-mode-montres-bijoux-bracelet-accessoires-de-mode-28': 'Bracelet',
  'accessoires-de-mode-montres-bijoux-broche-accessoires-de-mode-28': 'Broche',
  'accessoires-de-mode-montres-bijoux-chaine-accessoires-de-mode-28': 'Chaîne',
  'accessoires-de-mode-montres-bijoux-charm-accessoires-de-mode-28': 'Charm',
  'accessoires-de-mode-montres-bijoux-chevaliere-accessoires-de-mode-28': 'Chevalière',
  'accessoires-de-mode-montres-bijoux-collier-pendentif-accessoires-de-mode-28': 'Collier, pendentif',
  'accessoires-de-mode-montres-bijoux-gourmette-accessoires-de-mode-28': 'Gourmette',
  'accessoires-de-mode-montres-bijoux-montre-a-gousset-accessoires-de-mode-28': 'Montre à gousset',
  'accessoires-de-mode-montres-bijoux-montre-automatique-accessoires-de-mode-28': 'Montre automatique',
  'accessoires-de-mode-montres-bijoux-montre-bague-accessoires-de-mode-28': 'Montre-bague',
  'accessoires-de-mode-montres-bijoux-montre-connectee-accessoires-de-mode-28': 'Montre connectée',
  'accessoires-de-mode-montres-bijoux-montre-mecanique-accessoires-de-mode-28': 'Montre mécanique',
  'accessoires-de-mode-montres-bijoux-montre-pendentif-accessoires-de-mode-28': 'Montre-pendentif',
  'accessoires-de-mode-montres-bijoux-montre-quartz-accessoires-de-mode-28': 'Montre quartz',
  'accessoires-de-mode-montres-bijoux-montres-bijoux-divers-accessoires-de-mode-28': 'Montres & bijoux divers',
  'accessoires-de-mode-montres-bijoux-parure-accessoires-de-mode-28': 'Parure',
  'accessoires-de-mode-montres-bijoux-piercing-accessoires-de-mode-28': 'Piercing',
  'accessoires-de-mode-parapluie-accessoires-de-mode-28': 'Parapluie',
  'accessoires-de-mode-perruque-accessoires-de-mode-28': 'Perruque',
  'accessoires-de-mode-pochette-accessoires-de-mode-28': 'Pochette',
  'accessoires-de-mode-porte-cartes-accessoires-de-mode-28': 'Porte-cartes',
  'accessoires-de-mode-porte-chequier-accessoires-de-mode-28': 'Porte-chéquier',
  'accessoires-de-mode-porte-cles-accessoires-de-mode-28': 'Porte-clés',
  'accessoires-de-mode-porte-documents-serviette-accessoires-de-mode-28': 'Porte documents, serviette',
  'accessoires-de-mode-porte-monnaie-et-portefeuille-accessoires-de-mode-28': 'Porte-monnaie et portefeuille',
  'accessoires-de-mode-sacs-bagages-accessoires-de-mode-28': 'Sacs & bagages',
  'accessoires-de-mode-sacs-bagages-cartable-accessoires-de-mode-28': 'Cartable',
  'accessoires-de-mode-sacs-bagages-mallette-accessoires-de-mode-28': 'Mallette',
  'accessoires-de-mode-sacs-bagages-sac-a-dos-accessoires-de-mode-28': 'Sac à dos',
  'accessoires-de-mode-sacs-bagages-sac-a-main-accessoires-de-mode-28': 'Sac à main',
  'accessoires-de-mode-sacs-bagages-sac-de-sport-accessoires-de-mode-28': 'Sac de sport',
  'accessoires-de-mode-sacs-bagages-sac-de-voyage-accessoires-de-mode-28': 'Sac de voyage',
  'accessoires-de-mode-sacs-bagages-sac-en-bandouliere-accessoires-de-mode-28': 'Sac en bandoulière',
  'accessoires-de-mode-sacs-bagages-sacoche-accessoires-de-mode-28': 'Sacoche',
  'accessoires-de-mode-sacs-bagages-tote-bag-accessoires-de-mode-28': 'Tote bag',
  'accessoires-de-mode-sacs-bagages-trousse-accessoires-de-mode-28': 'Trousse',
  'accessoires-de-mode-sacs-bagages-valise-cabine-accessoires-de-mode-28': 'Valise cabine',
  'accessoires-de-mode-sacs-bagages-valise-moyenne-et-grande-taille-accessoires-de-mode-28': 'Valise moyenne et grande taille',
  'ameublement-meubles-24': 2,
  'ameublement-accessoire-meubles-24': 'Accessoire',
  'ameublement-armoire-meubles-24': 'Armoire',
  'ameublement-banc-meubles-24': 'Banc',
  'ameublement-bar-meubles-24': 'Bar',
  'ameublement-bibliotheque-et-etagere-meubles-24': 'Bibliothèque et étagère',
  'ameublement-buffet-meubles-24': 'Buffet',
  'ameublement-bureau-meubles-24': 'Bureau',
  'ameublement-cadre-de-lit-meubles-24': 'Cadre de lit',
  'ameublement-canape-convertible-et-clic-clac-meubles-24': 'Canapé convertible et clic clac',
  'ameublement-canape-meubles-24': 'Canapé',
  'ameublement-chaise-meubles-24': 'Chaise',
  'ameublement-coffre-et-malle-meubles-24': 'Coffre et malle',
  'ameublement-coiffeuse-meubles-24': 'Coiffeuse',
  'ameublement-commode-meubles-24': 'Commode',
  'ameublement-console-meubles-24': 'Console',
  'ameublement-douche-baignoire-meubles-24': 'Douche & baignoire',
  'ameublement-dressing-et-penderie-meubles-24': 'Dressing et penderie',
  'ameublement-fauteuil-meubles-24': 'Fauteuil',
  'ameublement-lit-meubles-24': 'Lit',
  'ameublement-lit-pour-enfant-meubles-24': 'Lit pour enfant',
  'ameublement-luminaire-meubles-24': 'Luminaire',
  'ameublement-luminaire-gande-lampe-meubles-24': 'Gande lampe',
  'ameublement-luminaire-lampe-de-bureau-meubles-24': 'Lampe de bureau',
  'ameublement-luminaire-lampe-de-chevet-meubles-24': 'Lampe de chevet',
  'ameublement-matelas-meubles-24': 'Matelas',
  'ameublement-meuble-de-cuisine-meubles-24': 'Meuble de cuisine',
  'ameublement-meuble-de-jardin-balancoire-meubles-24': 'Balancoire',
  'ameublement-meuble-de-jardin-meubles-24': 'Meuble de jardin',
  'ameublement-meuble-de-rangement-meubles-24': 'Meuble de rangement',
  'ameublement-meuble-de-salle-de-bain-meubles-24': 'Meuble de salle de bain',
  'ameublement-meuble-divers-meubles-24': 'Meuble divers',
  'ameublement-meuble-tv-meubles-24': 'Meuble TV',
  'ameublement-perforeuse-meubles-24': 'Perforeuse',
  'ameublement-porte-manteau-meubles-24': 'Porte-manteau',
  'ameublement-porte-meubles-24': 'Porte',
  'ameublement-sommier-meubles-24': 'Sommier',
  'ameublement-table-basse-meubles-24': 'Table basse',
  'ameublement-table-d-appoint-meubles-24': "Table d'appoint",
  'ameublement-table-de-chevet-meubles-24': 'Table de chevet',
  'ameublement-table-de-salle-a-manger-meubles-24': 'Table de salle à manger',
  'ameublement-table-meubles-24': 'Table',
  'ameublement-tabouret-meubles-24': 'Tabouret',
  'ameublement-tapis-meubles-24': 'Tapis',
  'ameublement-vaisselier-meubles-24': 'Vaisselier',
  'bricolage-jardinage-outillage-jardin-amenagement-exterieur-12': 3,
  'bricolage-jardinage-outillage-bricolage-bricolage-construction-et-renovation-6': 3,
  'bricolage-jardinage-outillage-bricolage-ampoules-bricolage-construction-et-renovation-6': 'Ampoules',
  'bricolage-jardinage-outillage-bricolage-bricolage-divers-bricolage-construction-et-renovation-6': 3,
  'bricolage-jardinage-outillage-bricolage-ferraille-bricolage-construction-et-renovation-6': 'Ferraille',
  'bricolage-jardinage-outillage-bricolage-huisserie-bricolage-construction-et-renovation-6': 'Huisserie',
  'bricolage-jardinage-outillage-bricolage-marteau-bricolage-construction-et-renovation-6': 'Marteau',
  'bricolage-jardinage-outillage-bricolage-metaux-divers-bricolage-construction-et-renovation-6': 'Métaux divers',
  'bricolage-jardinage-outillage-bricolage-outils-divers-bricolage-construction-et-renovation-6': 'Outils divers',
  'bricolage-jardinage-outillage-bricolage-peintures-mastic-droguerie-bricolage-construction-et-renovation-6': 'Peintures, mastic, droguerie',
  'bricolage-jardinage-outillage-bricolage-perceuse-bricolage-construction-et-renovation-6': 'Perceuse',
  'bricolage-jardinage-outillage-bricolage-pinceau-bricolage-construction-et-renovation-6': 'Pinceau',
  'bricolage-jardinage-outillage-bricolage-pistolet-a-etiquette-bricolage-construction-et-renovation-6': 'Pistolet à étiquette',
  'bricolage-jardinage-outillage-bricolage-planches-et-bois-bricolage-construction-et-renovation-6': 'Planches et Bois',
  'bricolage-jardinage-outillage-bricolage-platre-bricolage-construction-et-renovation-6': 'Plâtre',
  'bricolage-jardinage-outillage-bricolage-ponceuse-bricolage-construction-et-renovation-6': 'Ponceuse',
  'bricolage-jardinage-outillage-bricolage-roulettes-bricolage-construction-et-renovation-6': 'Roulettes',
  'bricolage-jardinage-outillage-bricolage-scie-bricolage-construction-et-renovation-6': 'Scie',
  'bricolage-jardinage-outillage-bricolage-scie-circulaire-bricolage-construction-et-renovation-6': 'Scie circulaire',
  'bricolage-jardinage-outillage-bricolage-scie-sauteuse-bricolage-construction-et-renovation-6': 'Scie sauteuse',
  'bricolage-jardinage-outillage-bricolage-tournevis-bricolage-construction-et-renovation-6': 'Tournevis',
  'bricolage-jardinage-outillage-bricolage-visserie-bricolage-construction-et-renovation-6': 'Visserie',
  'bricolage-jardinage-outillage-jardinage-jardin-amenagement-exterieur-12': 3,
  'bricolage-jardinage-outillage-jardinage-brouette-jardin-amenagement-exterieur-12': 'Brouette',
  'bricolage-jardinage-outillage-jardinage-debroussailleuse-jardin-amenagement-exterieur-12': 'Débroussailleuse',
  'bricolage-jardinage-outillage-jardinage-gants-de-jardinage-bricolage-jardin-amenagement-exterieur-12': 'Gants de jardinage & bricolage',
  'bricolage-jardinage-outillage-jardinage-graines-et-bulbes-jardin-amenagement-exterieur-12': 'Graines et bulbes',
  'bricolage-jardinage-outillage-jardinage-jardinage-divers-jardin-amenagement-exterieur-12': 'Jardinage divers',
  'bricolage-jardinage-outillage-jardinage-outils-divers-jardin-amenagement-exterieur-12': 'Outils divers',
  'bricolage-jardinage-outillage-jardinage-pot-de-fleurs-en-plastique-jardin-amenagement-exterieur-12': 'Pot de fleurs en plastique',
  'bricolage-jardinage-outillage-jardinage-pot-de-fleurs-en-terre-cuite-jardin-amenagement-exterieur-12': 'Pot de fleurs en terre cuite',
  'bricolage-jardinage-outillage-jardinage-rateau-jardin-amenagement-exterieur-12': 'Rateau',
  'bricolage-jardinage-outillage-jardinage-secateurs-jardin-amenagement-exterieur-12': 'Sécateurs',
  'bricolage-jardinage-outillage-jardinage-terre-jardin-amenagement-exterieur-12': 'Terre',
  'bricolage-jardinage-outillage-materiaux-de-construction-bricolage-construction-et-renovation-6': 3,
  'bricolage-jardinage-outillage-materiaux-de-construction-cloison-bois-et-panneaux-bricolage-construction-et-renovation-6': 'Cloison, bois et panneaux',
  'bricolage-jardinage-outillage-materiaux-de-construction-electricite-ventilation-bricolage-construction-et-renovation-6': 'Electricité, ventilation',
  'bricolage-jardinage-outillage-materiaux-de-construction-equipement-de-protection-securite-bricolage-construction-et-renovation-6': 'Equipement de protection, sécurité',
  'bricolage-jardinage-outillage-materiaux-de-construction-isolation-bricolage-construction-et-renovation-6': 'Isolation',
  'bricolage-jardinage-outillage-materiaux-de-construction-materiel-de-chantier-bricolage-construction-et-renovation-6': 'Matériel de chantier',
  'bricolage-jardinage-outillage-materiaux-de-construction-menuiserie-portes-fenetres-bricolage-construction-et-renovation-6': 'Menuiserie, Portes, fenêtres',
  'bricolage-jardinage-outillage-materiaux-de-construction-plafond-bricolage-construction-et-renovation-6': 'Plafond',
  'bricolage-jardinage-outillage-materiaux-de-construction-plomberie-bricolage-construction-et-renovation-6': 'Plomberie',
  'bricolage-jardinage-outillage-materiaux-de-construction-protection-solaire-photovoltaiques-bricolage-construction-et-renovation-6': 'Protection solaire, photovoltaïques',
  'bricolage-jardinage-outillage-materiaux-de-construction-quincaillerie-bricolage-construction-et-renovation-6': 'Quincaillerie',
  'bricolage-jardinage-outillage-materiaux-de-construction-revetement-exterieur-bricolage-construction-et-renovation-6': 'Revêtement extérieur',
  'bricolage-jardinage-outillage-materiaux-de-construction-sol-revetement-carrelage-parement-bricolage-construction-et-renovation-6': 'Sol, revêtement, carrelage, parement',
  'bricolage-jardinage-outillage-materiaux-de-construction-toiture-couverture-bricolage-construction-et-renovation-6': 'Toiture, Couverture',
  'bricolage-jardinage-outillage-outillage-bricolage-construction-et-renovation-6': 'Outillage',
  'chaussures-chaussures-27': 'Chaussures',
  'chaussures-ballerines-chaussures-27': 'Ballerines',
  'chaussures-baskets-sneakers-chaussures-27': 'Baskets & Sneakers',
  'chaussures-bottes-chaussures-27': 'Bottes',
  'chaussures-bottines-lowboots-chaussures-27': 'Bottines & lowboots',
  'chaussures-chaussons-pantoufles-chaussures-27': 'Chaussons & Pantoufles',
  'chaussures-chaussures-diverses-chaussures-27': 'Chaussures diverses',
  'chaussures-escarpins-chaussures-27': 'Escarpins',
  'chaussures-mocassins-chaussures-27': 'Mocassins',
  'chaussures-sandales-nu-pieds-chaussures-27': 'Sandales & Nu-pieds',
  'culture-livres-magazines-15': 8,
  'culture-billetterie-loisirs-22': 'Billetterie',
  'culture-cd-dvd-multimedia-high-tech-19': 'CD - DVD',
  'culture-culture-divers-loisirs-22': 8,
  'culture-livres-livres-magazines-15': 'Livres',
  'culture-livres-bande-dessinee-livres-magazines-15': 'Bande dessinée',
  'culture-livres-fantasy-sf-livres-magazines-15': 'Fantasy & SF',
  'culture-livres-livres-divers-livres-magazines-15': 'Livres divers',
  'culture-livres-manga-livres-magazines-15': 'Manga',
  'culture-livres-policier-thriller-livres-magazines-15': 'Policier & Thriller',
  'culture-livres-pour-les-enfants-livres-magazines-15': 'Pour les enfants',
  'culture-livres-roman-livres-magazines-15': 'Roman',
  'culture-livres-sciences-humaines-livres-magazines-15': 'Sciences humaines',
  'culture-livres-scolaire-soutien-scolaire-livres-magazines-15': 'Scolaire & soutien scolaire',
  'culture-lot-cd-dvd-livres-multimedia-high-tech-19': 'Lot CD, DVD, Livres',
  'culture-magazines-livres-magazines-15': 'Magazines',
  'culture-vinyl-multimedia-high-tech-19': 'Vinyl',
  emballages: 'Emballages',
  'emballages-bouteille-flacons-et-bidons-de-produits-menagers-plastique': 'Bouteille, flacons et bidons de produits ménagers (plastique)',
  'emballages-emballage-divers': 'Emballage divers',
  'emballages-emballage-en-papier': 'Emballage en papier',
  'emballages-emballage-en-polystyrene': 'Emballage en polystyrène',
  'emballages-emballage-et-produits-en-aluminium': 'Emballage et produits en aluminium',
  'emballages-emballage-et-produits-en-carton': 'Emballage et produits en Carton',
  'emballages-emballage-et-produits-en-metal': 'Emballage et produits en Métal',
  'emballages-emballage-et-produits-en-plastique': 'Emballage et produits en Plastique',
  'emballages-emballage-et-produits-en-verre-hors-vaisselle': 'Emballage et produits en Verre (hors vaisselle)',
  'emballages-films-sachets-et-barquettes-en-plastique': 'Films, sachets et barquettes en plastique',
  'emballages-yaourt-brique-de-lait': 'Yaourt, brique de lait…',
  'equipement-bebe-puericulture-20': 15,
  'equipement-bebe-babyphone-puericulture-20': 'Babyphone',
  'equipement-bebe-baignoire-puericulture-20': 'Baignoire',
  'equipement-bebe-barriere-de-securite-puericulture-20': 'Barrière de sécurité',
  'equipement-bebe-bavoir-puericulture-20': 'Bavoir',
  'equipement-bebe-berceau-puericulture-20': 'Berceau',
  'equipement-bebe-biberon-puericulture-20': 'Biberon',
  'equipement-bebe-chaise-haute-puericulture-20': 'Chaise haute',
  'equipement-bebe-chanceliere-puericulture-20': 'Chancelière',
  'equipement-bebe-chauffe-biberon-puericulture-20': 'Chauffe-biberon',
  'equipement-bebe-combinaison-puericulture-20': 'Combinaison',
  'equipement-bebe-couffin-puericulture-20': 'Couffin',
  'equipement-bebe-coussin-d-allaitement-puericulture-20': "Coussin d'allaitement",
  'equipement-bebe-equipement-bebe-divers-puericulture-20': 'Equipement bébé divers',
  'equipement-bebe-gigoteuse-puericulture-20': 'Gigoteuse',
  'equipement-bebe-humidificateur-puericulture-20': 'Humidificateur',
  'equipement-bebe-lit-bebe-puericulture-20': 'Lit bébé',
  'equipement-bebe-lit-parapluie-puericulture-20': 'Lit parapluie',
  'equipement-bebe-matelas-et-matelas-a-langer-puericulture-20': 'Matelas et matelas à langer',
  'equipement-bebe-nacelle-puericulture-20': 'Nacelle',
  'equipement-bebe-parc-puericulture-20': 'Parc',
  'equipement-bebe-porte-bebe-et-echarpe-de-portage-puericulture-20': 'Porte-bébé et écharpe de portage',
  'equipement-bebe-pot-et-siege-reducteur-puericulture-20': 'Pot et siège réducteur',
  'equipement-bebe-poubelle-a-couches-puericulture-20': 'Poubelle à couches',
  'equipement-bebe-poussette-puericulture-20': 'Poussette',
  'equipement-bebe-rehausseur-puericulture-20': 'Réhausseur',
  'equipement-bebe-sac-a-langer-puericulture-20': 'Sac à langer',
  'equipement-bebe-securite-domestique-puericulture-20': 'Sécurité domestique',
  'equipement-bebe-securite-exterieur-puericulture-20': 'Sécurité extérieur',
  'equipement-bebe-siege-auto-puericulture-20': 'Siège auto',
  'equipement-bebe-sterilisateur-puericulture-20': 'Stérilisateur',
  'equipement-bebe-table-a-langer-puericulture-20': 'Table à langer',
  'equipement-bebe-tapis-d-eveil-puericulture-20': "Tapis d'éveil",
  'equipement-bebe-tetine-puericulture-20': 'Tétine',
  'equipement-bebe-thermometre-puericulture-20': 'Thermomètre',
  'equipement-bebe-tire-lait-puericulture-20': 'Tire-lait',
  'equipement-bebe-tour-de-lit-bebe-puericulture-20': 'Tour de lit bébé',
  'equipement-bebe-transat-et-balancelle-puericulture-20': 'Transat et balancelle',
  'equipement-bebe-trotteur-puericulture-20': 'Trotteur',
  'equipement-bebe-vaisselle-puericulture-20': 'Vaisselle',
  'hygiene-soin-beaute-soins-du-corps-4': 11,
  'hygiene-soin-brosse-a-dent-beaute-soins-du-corps-4': 'Brosse à dent',
  'hygiene-soin-brosse-et-peigne-beaute-soins-du-corps-4': 'Brosse et peigne',
  'hygiene-soin-coloration-cheveux-beaute-soins-du-corps-4': 'Coloration cheveux',
  'hygiene-soin-coton-tiges-beaute-soins-du-corps-4': 'Coton-tiges',
  'hygiene-soin-couches-bebe-beaute-soins-du-corps-4': 'Couches bébé',
  'hygiene-soin-creme-huile-pour-le-corps-beaute-soins-du-corps-4': 'Crème & Huile pour le corps',
  'hygiene-soin-deodorant-beaute-soins-du-corps-4': 'Déodorant',
  'hygiene-soin-exfoliant-visage-beaute-soins-du-corps-4': 'Exfoliant visage',
  'hygiene-soin-gel-douche-beaute-soins-du-corps-4': 'Gel douche',
  'hygiene-soin-huile-d-argan-beaute-soins-du-corps-4': "Huile d'argan",
  'hygiene-soin-hygiene-soin-divers-beaute-soins-du-corps-4': 11,
  'hygiene-soin-lait-pour-le-corps-beaute-soins-du-corps-4': 'Lait pour le corps',
  'hygiene-soin-lingette-beaute-soins-du-corps-4': 'Lingette',
  'hygiene-soin-maquillage-beaute-soins-du-corps-4': 'Maquillage',
  'hygiene-soin-materiel-medical-beaute-soins-du-corps-4': 'Matériel médical',
  'hygiene-soin-pansements-patchs-et-semelles-beaute-soins-du-corps-4': 'Pansements, patchs et semelles',
  'hygiene-soin-parfum-beaute-soins-du-corps-4': 'Parfum',
  'hygiene-soin-rouge-a-levre-beaute-soins-du-corps-4': 'Rouge à lèvre',
  'hygiene-soin-savon-beaute-soins-du-corps-4': 'Savon',
  'hygiene-soin-shampoing-beaute-soins-du-corps-4': 'Shampoing',
  'hygiene-soin-soin-bebe-beaute-soins-du-corps-4': 'Soin bébé',
  'hygiene-soin-vernis-a-ongle-beaute-soins-du-corps-4': 'Vernis à ongle',
  'le-monde-des-animaux-accessoires-et-alimentation-animaux-1': 12,
  'le-monde-des-animaux-equipement-chat-accessoires-et-alimentation-animaux-1': 'Equipement Chat',
  'le-monde-des-animaux-equipement-chien-accessoires-et-alimentation-animaux-1': 'Equipement Chien',
  'le-monde-des-animaux-le-monde-des-animaux-divers-accessoires-et-alimentation-animaux-1': 12,
  'le-monde-des-animaux-nourriture-animaux-accessoires-et-alimentation-animaux-1': 'Nourriture animaux',
  'le-monde-des-animaux-pisciculture-viviculture-accessoires-et-alimentation-animaux-1': 'Pisciculture/Viviculture',
  'loisirs-jeux-loisirs-22': 7,
  'loisirs-jeux-doudous-et-peluches-jeux-et-jouets-13': 'Doudous et peluches',
  'loisirs-jeux-instruments-de-musique-loisirs-22': 'Instruments de musique',
  'loisirs-jeux-instruments-de-musique-guitare-acoustique-loisirs-22': 'Guitare acoustique',
  'loisirs-jeux-instruments-de-musique-guitare-electrique-loisirs-22': 'Guitare électrique',
  'loisirs-jeux-instruments-de-musique-instruments-musique-divers-loisirs-22': 'Instruments Musique divers',
  'loisirs-jeux-instruments-de-musique-piano-loisirs-22': 'Piano',
  'loisirs-jeux-instruments-de-musique-ukulele-loisirs-22': 'Ukulele',
  'loisirs-jeux-jouets-jeux-et-jouets-13': 'Jouets',
  'loisirs-jeux-jouets-cuisines-et-dinettes-jeux-et-jouets-13': 'Cuisines et dinettes',
  'loisirs-jeux-jouets-jeux-de-construction-jeux-et-jouets-13': 'Jeux de construction',
  'loisirs-jeux-jouets-jeux-de-societe-puzzle-jeux-et-jouets-13': 'Jeux de société / puzzle',
  'loisirs-jeux-jouets-jeux-educatifs-jeux-et-jouets-13': 'Jeux éducatifs',
  'loisirs-jeux-jouets-jeux-radiocommandes-jeux-et-jouets-13': 'Jeux radiocommandés',
  'loisirs-jeux-jouets-jouet-divers-jeux-et-jouets-13': 'Jouet divers',
  'loisirs-jeux-jouets-jouets-d-eveil-jeux-et-jouets-13': "Jouets d'éveil",
  'loisirs-jeux-jouets-porteurs-trotteurs-et-draisiennes-jeux-et-jouets-13': 'Porteurs, trotteurs et draisiennes',
  'loisirs-jeux-jouets-poupees-et-accessoires-jeux-et-jouets-13': 'Poupées et accessoires',
  'loisirs-jeux-jouets-trains-bateaux-et-avions-jeux-et-jouets-13': 'Trains, bateaux et avions',
  'loisirs-jeux-jouets-voitures-et-circuits-jeux-et-jouets-13': 'Voitures et circuits',
  'loisirs-jeux-loisirs-creatifs-loisirs-22': 'Loisirs créatifs',
  'loisirs-jeux-loisirs-creatifs-adhesifs-loisirs-22': 'Adhésifs',
  'loisirs-jeux-loisirs-creatifs-chutes-de-tissu-loisirs-22': 'Chutes de tissu',
  'loisirs-jeux-loisirs-creatifs-colle-loisirs-22': 'Colle',
  'loisirs-jeux-loisirs-creatifs-loisirs-creatifs-divers-loisirs-22': 'Loisirs créatifs divers',
  'loisirs-jeux-loisirs-creatifs-noeuds-loisirs-22': 'Noeuds',
  'loisirs-jeux-loisirs-creatifs-papeterie-carnet-loisirs-22': 6,
  'loisirs-jeux-loisirs-creatifs-pate-a-modeler-loisirs-22': 'Pâte à modeler',
  'loisirs-jeux-loisirs-creatifs-pate-fimo-loisirs-22': 'Pâte fimo',
  'loisirs-jeux-loisirs-creatifs-peinture-loisirs-22': 'Peinture',
  'loisirs-jeux-loisirs-creatifs-perles-pendentifs-loisirs-22': 'Perles & pendentifs',
  'loisirs-jeux-loisirs-creatifs-rubans-loisirs-22': 'Rubans',
  'loisirs-jeux-loisirs-creatifs-tableau-cadre-loisirs-22': 'Tableau & cadre',
  'loisirs-jeux-objets-de-collection-cartes-et-vignette-collection-7': 'Cartes et vignette',
  'loisirs-jeux-objets-de-collection-collection-7': 'Objets de collection',
  'loisirs-jeux-objets-de-collection-objet-de-collection-divers-collection-7': 'Objet de Collection divers',
  'loisirs-jeux-objets-de-collection-timbres-collection-7': 'Timbres',
  'loisirs-jeux-plein-air-barbecue-mobile-loisirs-22': 'Barbecue mobile',
  'loisirs-jeux-plein-air-bouee-de-piscine-loisirs-22': 'Bouée de piscine',
  'loisirs-jeux-plein-air-canne-a-peche-loisirs-22': 'Canne à pêche',
  'loisirs-jeux-plein-air-filet-de-peche-loisirs-22': 'Filet de pêche',
  'loisirs-jeux-plein-air-loisirs-22': 16,
  'loisirs-jeux-plein-air-matelas-de-camping-loisirs-22': 'Matelas de camping',
  'loisirs-jeux-plein-air-panier-de-peche-loisirs-22': 'Panier de pêche',
  'loisirs-jeux-plein-air-parasol-loisirs-22': 'Parasol',
  'loisirs-jeux-plein-air-plein-air-divers-loisirs-22': 16,
  'loisirs-jeux-plein-air-rechaud-loisirs-22': 'Réchaud',
  'loisirs-jeux-plein-air-sac-de-couchage-loisirs-22': 'Sac de couchage',
  'loisirs-jeux-plein-air-serviette-de-plage-loisirs-22': 'Serviette de plage',
  'loisirs-jeux-plein-air-tente-de-camping-loisirs-22': 'Tente de camping',
  'loisirs-jeux-plein-air-transat-loisirs-22': 'Transat',
  'maison-arts-de-la-table-arts-de-la-table-divers-cuisine-et-arts-la-table-2': 13,
  'maison-arts-de-la-table-assiette-cuisine-et-arts-la-table-2': 'Assiette',
  'maison-arts-de-la-table-beurrier-cuisine-et-arts-la-table-2': 'Beurrier',
  'maison-arts-de-la-table-bocaux-et-pots-cuisine-et-arts-la-table-2': 'Bocaux et pots',
  'maison-arts-de-la-table-boite-de-conservation-et-boite-en-metal-cuisine-et-arts-la-table-2': 'Boite de conservation et boite en metal',
  'maison-arts-de-la-table-bol-cuisine-et-arts-la-table-2': 'Bol',
  'maison-arts-de-la-table-bonbonniere-cuisine-et-arts-la-table-2': 'Bonbonnière',
  'maison-arts-de-la-table-carafe-et-pichet-cuisine-et-arts-la-table-2': 'Carafe et pichet',
  'maison-arts-de-la-table-casserole-cuisine-et-arts-la-table-2': 'Casserole',
  'maison-arts-de-la-table-casseroles-en-fonte-cuisine-et-arts-la-table-2': 'Casseroles en fonte',
  'maison-arts-de-la-table-cocotte-cuisine-et-arts-la-table-2': 'Cocotte',
  'maison-arts-de-la-table-coffret-cuisine-et-arts-la-table-2': 'Coffret',
  'maison-arts-de-la-table-coquetier-cuisine-et-arts-la-table-2': 'Coquetier',
  'maison-arts-de-la-table-corbeille-cuisine-et-arts-la-table-2': 'Corbeille',
  'maison-arts-de-la-table-coupe-et-coupelle-cuisine-et-arts-la-table-2': 'Coupe et coupelle',
  'maison-arts-de-la-table-couteaux-cuisine-et-arts-la-table-2': 'Couteaux',
  'maison-arts-de-la-table-couvercle-cuisine-et-arts-la-table-2': 'Couvercle',
  'maison-arts-de-la-table-couvert-cuisine-et-arts-la-table-2': 'Couvert',
  'maison-arts-de-la-table-cuisine-et-arts-la-table-2': 13,
  'maison-arts-de-la-table-dessous-de-plat-cuisine-et-arts-la-table-2': 'Dessous de plat',
  'maison-arts-de-la-table-flute-cuisine-et-arts-la-table-2': 'Flûte',
  'maison-arts-de-la-table-gourde-cuisine-et-arts-la-table-2': 'Gourde',
  'maison-arts-de-la-table-huilier-et-vinaigrier-cuisine-et-arts-la-table-2': 'Huilier et vinaigrier',
  'maison-arts-de-la-table-mazagran-cuisine-et-arts-la-table-2': 'Mazagran',
  'maison-arts-de-la-table-moule-cuisine-et-arts-la-table-2': 'Moule',
  'maison-arts-de-la-table-planche-a-decouper-cuisine-et-arts-la-table-2': 'Planche à découper',
  'maison-arts-de-la-table-plat-a-four-et-a-tarte-cuisine-et-arts-la-table-2': 'Plat à four et à tarte',
  'maison-arts-de-la-table-plat-aperitif-cuisine-et-arts-la-table-2': 'Plat apéritif',
  'maison-arts-de-la-table-plat-de-service-cuisine-et-arts-la-table-2': 'Plat de service',
  'maison-arts-de-la-table-plateau-cuisine-et-arts-la-table-2': 'Plateau',
  'maison-arts-de-la-table-poele-cuisine-et-arts-la-table-2': 'Poële',
  'maison-arts-de-la-table-ramequin-cuisine-et-arts-la-table-2': 'Ramequin',
  'maison-arts-de-la-table-rond-de-serviette-cuisine-et-arts-la-table-2': 'Rond de serviette',
  'maison-arts-de-la-table-saladier-cuisine-et-arts-la-table-2': 'Saladier',
  'maison-arts-de-la-table-saliere-poivriere-et-sucrier-cuisine-et-arts-la-table-2': 'Salière, poivrière et sucrier',
  'maison-arts-de-la-table-sauciere-cuisine-et-arts-la-table-2': 'Saucière',
  'maison-arts-de-la-table-seau-a-glacons-cuisine-et-arts-la-table-2': 'Seau à glaçons',
  'maison-arts-de-la-table-service-a-cafe-ou-a-the-cuisine-et-arts-la-table-2': 'Service à café ou à thé',
  'maison-arts-de-la-table-service-de-vaisselle-cuisine-et-arts-la-table-2': 'Service de vaisselle',
  'maison-arts-de-la-table-set-de-table-cuisine-et-arts-la-table-2': 'Set de table',
  'maison-arts-de-la-table-shaker-cuisine-et-arts-la-table-2': 'Shaker',
  'maison-arts-de-la-table-soucoupe-cuisine-et-arts-la-table-2': 'Soucoupe',
  'maison-arts-de-la-table-soupiere-cuisine-et-arts-la-table-2': 'Soupière',
  'maison-arts-de-la-table-sous-verre-cuisine-et-arts-la-table-2': 'Sous verre',
  'maison-arts-de-la-table-tasse-et-mug-cuisine-et-arts-la-table-2': 'Tasse et mug',
  'maison-arts-de-la-table-terrine-cuisine-et-arts-la-table-2': 'Terrine',
  'maison-arts-de-la-table-theiere-tisaniere-cuisine-et-arts-la-table-2': 'Théière, tisanière',
  'maison-arts-de-la-table-tire-bouchon-cuisine-et-arts-la-table-2': 'Tire-bouchon',
  'maison-arts-de-la-table-torchon-cuisine-et-arts-la-table-2': 'Torchon',
  'maison-arts-de-la-table-ustensile-de-cuisine-cuisine-et-arts-la-table-2': 'Ustensile de cuisine',
  'maison-arts-de-la-table-verre-cuisine-et-arts-la-table-2': 'Verre',
  'maison-arts-de-la-table-verrine-cuisine-et-arts-la-table-2': 'Verrine',
  'maison-decoration-abat-jour-decoration-25': 'Abat-jour',
  'maison-decoration-accessoire-de-rangement-decoration-25': 'Accessoire de rangement',
  'maison-decoration-accessoire-de-salle-de-bain-decoration-25': 'Accessoire de salle de bain',
  'maison-decoration-applique-decoration-25': 'Applique',
  'maison-decoration-bibelot-decoration-25': 'Bibelot',
  'maison-decoration-bougie-et-photophore-decoration-25': 'Bougie et photophore',
  'maison-decoration-bouquet-et-plante-artificielle-decoration-25': 'Bouquet et plante artificielle',
  'maison-decoration-cadre-photo-decoration-25': 'Cadre photo',
  'maison-decoration-cendrier-et-vide-poche-decoration-25': 'Cendrier et vide-poche',
  'maison-decoration-coussin-decoration-25': 'Coussin',
  'maison-decoration-dame-jeanne-et-bonbonne-decoration-25': 'Dame-jeanne et bonbonne',
  'maison-decoration-decoration-25': 'Décoration',
  'maison-decoration-decoration-diverse-decoration-25': 'Décoration diverse',
  'maison-decoration-guirlande-decoration-25': 'Guirlande',
  'maison-decoration-horloge-pendule-et-reveil-decoration-25': 'Horloge, pendule et réveil',
  'maison-decoration-lustre-decoration-25': 'Lustre',
  'maison-decoration-miroir-decoration-25': 'Miroir',
  'maison-decoration-panier-boite-tupperware-decoration-25': 'Panier, boite, tupperware',
  'maison-decoration-papier-peint-decoration-25': 'Papier peint',
  'maison-decoration-paravent-decoration-25': 'Paravent',
  'maison-decoration-pele-mele-photo-decoration-25': 'Pêle-mêle photo',
  'maison-decoration-pelotte-de-laine-decoration-25': 'Pelotte de laine',
  'maison-decoration-plante-decoration-25': 'Plante',
  'maison-decoration-rideaux-voilage-et-store-decoration-25': 'Rideaux, voilage et store',
  'maison-decoration-sculpture-et-statue-decoration-25': 'Sculpture et statue',
  'maison-decoration-tableau-et-toile-decoration-25': 'Tableau et toile',
  'maison-decoration-tapis-decoration-25': 'Tapis',
  'maison-decoration-vase-cache-pot-et-ceramique-decoration-25': 'Vase, cache pot et céramique',
  'maison-entretien-nettoyage-balai-entretien-de-la-maison-accessoires-et-produits-10': 'Balai',
  'maison-entretien-nettoyage-entretien-de-la-maison-accessoires-et-produits-10': 'Entretien & Nettoyage',
  'maison-entretien-nettoyage-eponge-entretien-de-la-maison-accessoires-et-produits-10': 'Eponge',
  'maison-entretien-nettoyage-javel-entretien-de-la-maison-accessoires-et-produits-10': 'Javel',
  'maison-entretien-nettoyage-lessive-entretien-de-la-maison-accessoires-et-produits-10': 'Lessive',
  'maison-entretien-nettoyage-liquide-vaisselle-entretien-de-la-maison-accessoires-et-produits-10': 'Liquide vaisselle',
  'maison-entretien-nettoyage-pastilles-de-lave-vaisselle-entretien-de-la-maison-accessoires-et-produits-10': 'Pastilles de lave vaisselle',
  'maison-gros-electromenager-appareil-de-cuisson-electromenager-9': 'Appareil de cuisson',
  'maison-gros-electromenager-cave-a-vin-electromenager-9': 'Cave à vin',
  'maison-gros-electromenager-climatiseur-electromenager-9': 'Climatiseur',
  'maison-gros-electromenager-congelateur-electromenager-9': 'Congélateur',
  'maison-gros-electromenager-cuisiniere-electromenager-9': 'Cuisinière',
  'maison-gros-electromenager-electromenager-9': 14,
  'maison-gros-electromenager-four-electromenager-9': 'Four',
  'maison-gros-electromenager-four-professionnel-electromenager-9': 'Four professionnel',
  'maison-gros-electromenager-frigo-americain-electromenager-9': 'Frigo américain',
  'maison-gros-electromenager-frigo-electromenager-9': 'Frigo',
  'maison-gros-electromenager-gaziniere-electromenager-9': 'Gazinière',
  'maison-gros-electromenager-gros-electromenager-divers-electromenager-9': 14,
  'maison-gros-electromenager-hotte-electromenager-9': 'Hotte',
  'maison-gros-electromenager-lave-linge-electromenager-9': 'Lave-linge',
  'maison-gros-electromenager-lave-vaisselle-electromenager-9': 'Lave-vaisselle',
  'maison-gros-electromenager-machine-a-laver-electromenager-9': 'Machine à laver',
  'maison-gros-electromenager-piano-de-cuisson-electromenager-9': 'Piano de cuisson',
  'maison-gros-electromenager-plaque-de-cuisson-electromenager-9': 'Plaque de cuisson',
  'maison-gros-electromenager-refrigerateur-electromenager-9': 'Réfrigérateur',
  'maison-gros-electromenager-seche-linge-electromenager-9': 'Sèche linge',
  'maison-linge-de-maison-deco-textile-linge-de-maison-14': 'Déco textile',
  'maison-linge-de-maison-draps-linge-de-maison-14': 'Draps',
  'maison-linge-de-maison-linge-de-bain-linge-de-maison-14': 'Linge de bain',
  'maison-linge-de-maison-linge-de-lit-linge-de-maison-14': 'Linge de lit',
  'maison-linge-de-maison-linge-de-maison-14': 'Linge de maison',
  'maison-linge-de-maison-linge-de-maison-divers-linge-de-maison-14': 'Linge de Maison Divers',
  'maison-linge-de-maison-linge-de-table-linge-de-maison-14': 'Linge de table',
  'maison-meubles-24': 13,
  'maison-petit-electromenager-appareil-de-massage-electromenager-9': 'Appareil de massage',
  'maison-petit-electromenager-aspirateur-electromenager-9': 'Aspirateur',
  'maison-petit-electromenager-autres-robots-electromenager-9': 'Autres robots',
  'maison-petit-electromenager-balance-de-cuisine-electromenager-9': 'Balance de cuisine',
  'maison-petit-electromenager-barbecue-et-plancha-electrique-electromenager-9': 'Barbecue et plancha électrique',
  'maison-petit-electromenager-batterie-externe-electromenager-9': 'Batterie externe',
  'maison-petit-electromenager-bouilloire-electromenager-9': 'Bouilloire',
  'maison-petit-electromenager-brosse-a-dent-electrique-electromenager-9': 'Brosse à dent électrique',
  'maison-petit-electromenager-brosse-coiffante-electromenager-9': 'Brosse coiffante',
  'maison-petit-electromenager-centre-de-repassage-electromenager-9': 'Centre de repassage',
  'maison-petit-electromenager-chauffage-d-appoint-electromenager-9': "Chauffage d'appoint",
  'maison-petit-electromenager-defroisseur-electromenager-9': 'Défroisseur',
  'maison-petit-electromenager-electromenager-9': 14,
  'maison-petit-electromenager-epilateur-electromenager-9': 'Epilateur',
  'maison-petit-electromenager-extracteur-de-jus-electromenager-9': 'Extracteur de jus',
  'maison-petit-electromenager-fer-a-boucler-electromenager-9': 'Fer à boucler',
  'maison-petit-electromenager-fer-a-repasser-electromenager-9': 'Fer à repasser',
  'maison-petit-electromenager-four-a-micro-ondes-electromenager-9': 'Four à micro-ondes',
  'maison-petit-electromenager-grille-pain-electromenager-9': 'Grille-pain',
  'maison-petit-electromenager-lisseur-electromenager-9': 'Lisseur',
  'maison-petit-electromenager-machine-a-cafe-electromenager-9': 'Machine à café',
  'maison-petit-electromenager-machine-a-coudre-electromenager-9': 'Machine à coudre',
  'maison-petit-electromenager-machine-a-pain-electromenager-9': 'Machine à pain',
  'maison-petit-electromenager-machine-a-soda-electromenager-9': 'Machine à soda',
  'maison-petit-electromenager-machine-a-the-electromenager-9': 'Machine à thé',
  'maison-petit-electromenager-mini-four-electrique-electromenager-9': 'Mini four électrique',
  'maison-petit-electromenager-mixeur-electromenager-9': 'Mixeur',
  'maison-petit-electromenager-nettoyeur-vapeur-electromenager-9': 'Nettoyeur vapeur',
  'maison-petit-electromenager-pese-personne-electromenager-9': 'Pèse personne',
  'maison-petit-electromenager-petit-electromenager-divers-electromenager-9': 14,
  'maison-petit-electromenager-rasoir-electrique-electromenager-9': 'Rasoir électrique',
  'maison-petit-electromenager-reveil-electromenager-9': 'Réveil',
  'maison-petit-electromenager-robot-cuiseur-electromenager-9': 'Robot cuiseur',
  'maison-petit-electromenager-robot-multifonction-electromenager-9': 'Robot multifonction',
  'maison-petit-electromenager-robot-patissier-electromenager-9': 'Robot pâtissier',
  'maison-petit-electromenager-seche-cheveux-electromenager-9': 'Sèche-cheveux',
  'maison-petit-electromenager-sorbetiere-electromenager-9': 'Sorbetière',
  'maison-petit-electromenager-tireuse-a-biere-electromenager-9': 'Tireuse à bière',
  'maison-petit-electromenager-tondeuse-electromenager-9': 'Tondeuse',
  'maison-petit-electromenager-ventilateur-electromenager-9': 'Ventilateur',
  'maison-petit-electromenager-yaourtiere-electromenager-9': 'Yaourtière',
  'maison-rangements-et-organisation-boites-decoration-25': 'Boites',
  'maison-rangements-et-organisation-cartons-decoration-25': 'Cartons',
  'maison-rangements-et-organisation-decoration-25': 'Rangements et organisation',
  'maison-rangements-et-organisation-rangement-et-organisation-divers-decoration-25': 'Rangement et organisation Divers',
  'materiel-professionnel-btp-gros-oeuvre-materiel-specialise-17': 'BTP - Gros-oeuvre',
  'materiel-professionnel-fournitures-de-bureau-fournitures-de-bureau-divers-materiel-de-bureau-scolaire-16': 6,
  'materiel-professionnel-fournitures-de-bureau-materiel-de-bureau-scolaire-16': 6,
  'materiel-professionnel-fournitures-de-bureau-stylo-et-crayons-materiel-de-bureau-scolaire-16': 'Stylo et crayons',
  'materiel-professionnel-materiel-medical-materiel-specialise-17': 'Matériel médical',
  'materiel-professionnel-materiel-professionnel-divers-materiel-specialise-17': 5,
  'materiel-professionnel-materiel-specialise-17': 5,
  'multimedia-cables-connectique-multimedia-high-tech-19': 'Câbles & connectique',
  'multimedia-calculatrice-multimedia-high-tech-19': 'Calculatrice',
  'multimedia-consoles-jeux-video-console-de-salon-multimedia-high-tech-19': 'Console de salon',
  'multimedia-consoles-jeux-video-console-portable-multimedia-high-tech-19': 'Console portable',
  'multimedia-consoles-jeux-video-consoles-jeux-video-divers-multimedia-high-tech-19': 'Consoles & Jeux vidéo divers',
  'multimedia-consoles-jeux-video-jeux-video-multimedia-high-tech-19': 'Jeux video',
  'multimedia-consoles-jeux-video-multimedia-high-tech-19': 'Consoles & Jeux vidéo',
  'multimedia-decodeur-multimedia-high-tech-19': 'Décodeur',
  'multimedia-image-son-appareil-photo-multimedia-high-tech-19': 'Appareil photo',
  'multimedia-image-son-baladeurs-numeriques-multimedia-high-tech-19': 'Baladeurs numériques',
  'multimedia-image-son-barre-de-son-multimedia-high-tech-19': 'Barre de son',
  'multimedia-image-son-cadre-photo-numerique-multimedia-high-tech-19': 'Cadre photo numérique',
  'multimedia-image-son-casque-audio-multimedia-high-tech-19': 'Casque audio',
  'multimedia-image-son-enceinte-bluetooth-multimedia-high-tech-19': 'Enceinte Bluetooth',
  'multimedia-image-son-home-cinema-multimedia-high-tech-19': 'Home cinéma',
  'multimedia-image-son-image-son-divers-multimedia-high-tech-19': 'Image & Son divers',
  'multimedia-image-son-lecteur-dvd-multimedia-high-tech-19': 'Lecteur DVD',
  'multimedia-image-son-liseuse-multimedia-high-tech-19': 'Liseuse',
  'multimedia-image-son-multimedia-high-tech-19': 'Image & Son',
  'multimedia-image-son-telecommande-multimedia-high-tech-19': 'Télécommande',
  'multimedia-image-son-television-multimedia-high-tech-19': 'Télévision',
  'multimedia-image-son-video-projecteur-multimedia-high-tech-19': 'Vidéo projecteur',
  'multimedia-informatique-baies-de-disques-multimedia-high-tech-19': 'Baies de disques',
  'multimedia-informatique-cartouche-d-encre-multimedia-high-tech-19': "Cartouche d'encre",
  'multimedia-informatique-clavier-multimedia-high-tech-19': 'Clavier',
  'multimedia-informatique-ecran-d-ordinateur-multimedia-high-tech-19': "Ecran d'ordinateur",
  'multimedia-informatique-imprimante-laser-multimedia-high-tech-19': 'Imprimante laser',
  'multimedia-informatique-imprimante-multimedia-high-tech-19': 'Imprimante',
  'multimedia-informatique-informatique-divers-multimedia-high-tech-19': 'Informatique divers',
  'multimedia-informatique-modem-multimedia-high-tech-19': 'Modem',
  'multimedia-informatique-multimedia-high-tech-19': 'Informatique',
  'multimedia-informatique-ordinateur-fixe-multimedia-high-tech-19': 'Ordinateur fixe',
  'multimedia-informatique-ordinateur-portable-multimedia-high-tech-19': 'Ordinateur portable',
  'multimedia-informatique-souris-multimedia-high-tech-19': 'Souris',
  'multimedia-informatique-webcam-multimedia-high-tech-19': 'Webcam',
  'multimedia-multimedia-high-tech-19': 9,
  'multimedia-outils-divers-multimedia-high-tech-19': 'Outils divers',
  'multimedia-photocopieurs-multimedia-high-tech-19': 'Photocopieurs',
  'multimedia-radio-multimedia-high-tech-19': 'Radio',
  'multimedia-tablette-multimedia-high-tech-19': 'Tablette',
  'multimedia-telephonie-batterie-de-telephone-multimedia-high-tech-19': 'Batterie de téléphone',
  'multimedia-telephonie-multimedia-high-tech-19': 'Téléphonie',
  'multimedia-telephonie-telephone-fixe-multimedia-high-tech-19': 'Téléphone fixe',
  'multimedia-telephonie-telephone-portable-smartphone-multimedia-high-tech-19': 'Téléphone portable, Smartphone',
  'multimedia-telephonie-telephonie-divers-multimedia-high-tech-19': 'Téléphonie divers',
  'nourriture-alimentaire-29': 10,
  'nourriture-conserve-alimentaire-29': 'Conserve',
  'nourriture-epicerie-salee-alimentaire-29': 'Epicerie salée',
  'nourriture-epicerie-sucree-alimentaire-29': 'Epicerie sucrée',
  'sport-basket-ball-ballon-sport-21': 'Ballon',
  'sport-basket-ball-basket-ball-divers-sport-21': 'Basket-Ball divers',
  'sport-basket-ball-panier-exterieur-avec-socle-sport-21': 'Panier extérieur avec socle',
  'sport-basket-ball-panier-interieur-fixe-avec-socle-sport-21': 'Panier intérieur fixe avec socle',
  'sport-basket-ball-sport-21': 'Basket-Ball',
  'sport-cyclisme-accessoire-velo-sport-21': 'Accessoire vélo',
  'sport-cyclisme-chambre-a-air-sport-21': 'Chambre à air',
  'sport-cyclisme-cyclisme-divers-sport-21': 'Cyclisme divers',
  'sport-cyclisme-piece-de-velo-sport-21': 'Pièce de vélo',
  'sport-cyclisme-pneu-sport-21': 'Pneu',
  'sport-cyclisme-sport-21': 'Cyclisme',
  'sport-cyclisme-velo-d-appartement-sport-21': "Vélo d'appartement",
  'sport-cyclisme-velo-de-course-sport-21': 'Vélo de course',
  'sport-cyclisme-velo-de-ville-vtc-sport-21': 'Vélo de ville, VTC',
  'sport-cyclisme-velo-electrique-sport-21': 'Vélo électrique',
  'sport-cyclisme-velo-enfant-sport-21': 'Vélo enfant',
  'sport-cyclisme-vtt-sport-21': 'VTT',
  'sport-divers-paire-de-rollers-sport-21': 'Paire de rollers',
  'sport-divers-skateboard-sport-21': 'Skateboard',
  'sport-divers-sport-21': 'Divers',
  'sport-divers-trampoline-sport-21': 'Trampoline',
  'sport-divers-trotinette-sport-21': 'Trotinette',
  'sport-equitation-bombe-sport-21': 'Bombe',
  'sport-equitation-cravache-sport-21': 'Cravache',
  'sport-equitation-equitation-divers-sport-21': 'Equitation divers',
  'sport-equitation-harnais-sport-21': 'Harnais',
  'sport-equitation-selle-sport-21': 'Selle',
  'sport-equitation-sport-21': 'Equitation',
  'sport-escrime-epee-sport-21': 'Épée',
  'sport-escrime-fleuret-sport-21': 'Fleuret',
  'sport-escrime-masque-sport-21': 'Masque',
  'sport-escrime-sabre-sport-21': 'Sabre',
  'sport-escrime-sport-21': 'Escrime',
  'sport-football-ballon-sport-21': 'Ballon',
  'sport-football-cage-de-foot-sport-21': 'Cage de foot',
  'sport-football-football-divers-sport-21': 'Football divers',
  'sport-football-protege-tibia-sport-21': 'Protège tibia',
  'sport-football-sport-21': 'Football',
  'sport-golf-balle-sport-21': 'Balle',
  'sport-golf-club-sport-21': 'Club',
  'sport-golf-golf-divers-sport-21': 'Golf divers',
  'sport-golf-sport-21': 'Golf',
  'sport-gymnastique-agres-barre-fixe-sport-21': 'Agrès barre fixe',
  'sport-gymnastique-agres-barres-assymetriques-sport-21': 'Agrès barres assymétriques',
  'sport-gymnastique-agres-barres-paralleles-sport-21': 'Agrès barres parallèles',
  'sport-gymnastique-gymnastique-divers-sport-21': 'Gymnastique divers',
  'sport-gymnastique-sport-21': 'Gymnastique',
  'sport-gymnastique-tatami-sport-21': 'Tatami',
  'sport-handball-ballon-sport-21': 'Ballon',
  'sport-handball-handball-divers-sport-21': 'Handball divers',
  'sport-handball-sport-21': 'Handball',
  'sport-judo-ceinture-d-art-martial-sport-21': "Ceinture d'art martial",
  'sport-judo-judo-divers-sport-21': 'Judo divers',
  'sport-judo-kimono-sport-21': 'Kimono',
  'sport-judo-sport-21': 'Judo',
  'sport-judo-tatami-sport-21': 'Tatami',
  'sport-materiel-de-chasse-sport-21': 'Matériel de chasse',
  'sport-musculation-et-fitness-sport-21': 'Musculation et fitness',
  'sport-natation-lunettes-de-natation-sport-21': 'Lunettes de natation',
  'sport-natation-maillot-sport-21': 'Maillot',
  'sport-natation-masque-sport-21': 'Masque',
  'sport-natation-natation-divers-sport-21': 'Natation divers',
  'sport-natation-pince-nez-sport-21': 'Pince nez',
  'sport-natation-sport-21': 'Natation',
  'sport-natation-tuba-sport-21': 'Tuba',
  'sport-plongee-bouteille-sport-21': 'Bouteille',
  'sport-plongee-masque-sport-21': 'Masque',
  'sport-plongee-plongee-divers-sport-21': 'Plongée divers',
  'sport-plongee-sport-21': 'Plongée',
  'sport-plongee-tuba-sport-21': 'Tuba',
  'sport-randonnee-batons-de-marche-sport-21': 'Batons de marche',
  'sport-randonnee-randonnee-divers-sport-21': 'Randonnée divers',
  'sport-randonnee-sac-a-dos-de-randonnee-sport-21': 'Sac à dos de randonnée',
  'sport-randonnee-sport-21': 'Randonnée',
  'sport-randonnee-tente-sport-21': 'Tente',
  'sport-sport-21': 16,
  'sport-sport-d-hiver-batons-de-ski-sport-21': 'Batons de ski',
  'sport-sport-d-hiver-casque-de-ski-sport-21': 'Casque de ski',
  'sport-sport-d-hiver-paire-de-skis-sport-21': 'Paire de skis',
  'sport-sport-d-hiver-snowboard-sport-21': 'Snowboard',
  'sport-sport-d-hiver-sport-21': "Sport d'hiver",
  'sport-sport-d-hiver-sport-d-hiver-divers-sport-21': "Sport d'hiver divers",
  'sport-sport-de-combat-gants-de-boxe-sport-21': 'Gants de boxe',
  'sport-sport-de-combat-sac-de-frappe-sport-21': 'Sac de frappe',
  'sport-sport-de-combat-sport-21': 'Sport de combat',
  'sport-sport-de-combat-sport-de-combat-divers-sport-21': 'Sport de Combat divers',
  'sport-sport-nautique-planche-a-voile-sport-21': 'Planche à voile',
  'sport-sport-nautique-planche-de-surf-sport-21': 'Planche de surf',
  'sport-sport-nautique-sport-21': 'Sport nautique',
  'sport-sport-nautique-sport-nautique-divers-sport-21': 'Sport Nautique divers',
  'sport-sport-nautique-voile-sport-21': 'Voile',
  'sport-tennis-balle-sport-21': 'Balle',
  'sport-tennis-raquette-sport-21': 'Raquette',
  'sport-tennis-sport-21': 'Tennis',
  'sport-tennis-tennis-divers-sport-21': 'Tennis divers',
  'sport-volleyball-ballon-sport-21': 'Ballon',
  'sport-volleyball-sport-21': 'Volleyball',
  'sport-volleyball-volleyball-divers-sport-21': 'Volleyball divers',
  'sport-yoga-sport-21': 'Yoga',
  'sport-yoga-tapis-de-yoga-sport-21': 'Tapis de yoga',
  'sport-yoga-yoga-divers-sport-21': 'Yoga divers',
  'vehicule-auto-moto-vehicules-3': 17,
  'vehicule-caravaning-auto-moto-vehicules-3': 'Caravaning',
  'vehicule-equipement-auto-auto-moto-vehicules-3': 'Equipement auto',
  'vehicule-equipement-caravaning-auto-moto-vehicules-3': 'Equipement caravaning',
  'vehicule-equipement-moto-auto-moto-vehicules-3': 'Equipement moto',
  'vehicule-equipement-nautisme-auto-moto-vehicules-3': 'Equipement nautisme',
  'vehicule-equipement-utilitaires-auto-moto-vehicules-3': 'Equipement utilitaires',
  'vehicule-motos-auto-moto-vehicules-3': 'Motos',
  'vehicule-nautisme-auto-moto-vehicules-3': 'Nautisme',
  'vehicule-pneumatique-moto-auto-moto-vehicules-3': 'Pneumatique moto',
  'vehicule-pneumatique-voiture-auto-moto-vehicules-3': 'Pneumatique voiture',
  'vehicule-utilitaire-auto-moto-vehicules-3': 'Utilitaire',
  'vehicule-vehicule-divers-auto-moto-vehicules-3': 17,
  'vehicule-voitures-auto-moto-vehicules-3': 'Voitures',
  'vetements-bodies-bebe-vetements-26': 'Bodies bébé',
  'vetements-bonnets-chapeaux-bonnet-vetements-26': 'Bonnet',
  'vetements-bonnets-chapeaux-casquette-vetements-26': 'Casquette',
  'vetements-bonnets-chapeaux-chapeau-vetements-26': 'Chapeau',
  'vetements-bonnets-chapeaux-vetements-26': 'Bonnets & Chapeaux',
  'vetements-chemises-chemisiers-vetements-26': 'Chemises / Chemisiers',
  'vetements-costumes-tailleurs-vetements-26': 'Costumes / Tailleurs',
  'vetements-deguisement-vetements-26': 'Déguisement',
  'vetements-ensembles-combinaisons-vetements-26': 'Ensembles & Combinaisons',
  'vetements-hauts-t-shirts-vetements-26': 'Hauts & T-Shirts',
  'vetements-jeans-vetements-26': 'Jeans',
  'vetements-jupe-vetements-26': 'Jupe',
  'vetements-lot-de-vetements-vetements-26': 'Lot de vêtements',
  'vetements-maillots-de-bain-vetements-de-plage-vetements-26': 'Maillots de bain & vêtements de plage',
  'vetements-manteaux-vestes-vetements-26': 'Manteaux & Vestes',
  'vetements-mariage-vetements-26': 'Mariage',
  'vetements-pantalons-vetements-26': 'Pantalons',
  'vetements-polaire-vetements-26': 'Polaire',
  'vetements-polo-vetements-26': 'Polo',
  'vetements-pulls-gilets-vetements-26': 'Pulls & Gilets',
  'vetements-pyjamas-vetements-de-nuit-vetements-26': 'Pyjamas & vêtements de nuit',
  'vetements-robes-jupes-vetements-26': 'Robes & jupes',
  'vetements-shorts-pantacourts-bermudas-vetements-26': 'Shorts / Pantacourts / Bermudas',
  'vetements-sous-vetements-calecon-vetements-26': 'Caleçon',
  'vetements-sous-vetements-culotte-vetements-26': 'Culotte',
  'vetements-sous-vetements-ensemble-lingerie-vetements-26': 'Ensemble lingerie',
  'vetements-sous-vetements-slip-vetements-26': 'Slip',
  'vetements-sous-vetements-soutiens-gorge-vetements-26': 'Soutiens-gorge',
  'vetements-sous-vetements-vetements-26': 'Sous-vêtements',
  'vetements-sweat-vetements-26': 'Sweat',
  'vetements-vetement-divers-vetements-26': 'Vêtement divers',
  'vetements-vetements-26': 1,
  'vetements-vetements-equipements-de-sport-vetements-26': 'Vêtements / équipements de sport',
  bouchons: 'Bouchons',
  'bouchons-bouchon-en-liege': 'Bouchon en liège',
  'bouchons-bouchon-en-plastique': 'Bouchon en plastique',
  'bouchons-bouchons-divers': 'Bouchons divers',
  'categorisation-en-cours': 'Catégorisation en cours',
  'dechets-alimentaires': 'Déchets Alimentaires',
  'dechets-alimentaires-cafe': 'Café',
  'dechets-alimentaires-capsule-cafe': 'Capsule Café',
  'dechets-alimentaires-dechet-alimentaire-divers': 'Déchet alimentaire divers',
  'dechets-alimentaires-epluchures-fruits-et-legumes': 'Epluchures fruits et légumes',
  'dechets-alimentaires-huile-de-friture': 'Huile de friture',
  'dechets-alimentaires-reste-de-repas': 'Reste de repas',
  'dechets-construction-bricolage': 'Déchets Construction & Bricolage',
  'dechets-construction-bricolage-ampoules-ou-neons-usages': 'Ampoules ou néons usagés',
  'dechets-construction-bricolage-dechets-construction-divers': 'Déchets Construction Divers',
  'dechets-construction-bricolage-dechets-textiles': 'Déchets Textiles',
  'dechets-construction-bricolage-ferraille': 'Ferraille',
  'dechets-construction-bricolage-gravats-et-deblais': 'Gravats et déblais',
  'dechets-construction-bricolage-huisserie': 'Huisserie',
  'dechets-construction-bricolage-metaux-non-ferreux': 'Métaux non-ferreux',
  'dechets-construction-bricolage-planches-et-bois': 'Planches et Bois',
  'dechets-construction-bricolage-platre': 'Plâtre',
  'dechets-dangereux': 'Déchets dangereux',
  'dechets-dangereux-allume-feu': 'Allume-feu',
  'dechets-dangereux-batterie-accumulateurs': 'Batterie & accumulateurs',
  'dechets-dangereux-bouteilles-et-cartouches-de-gaz-usagees': 'Bouteilles et cartouches de gaz usagées',
  'dechets-dangereux-colles-pour-sol-et-mur-usagees': 'Colles pour sol et mur usagées',
  'dechets-dangereux-extincteurs-usages': 'Extincteurs usagés',
  'dechets-dangereux-huile-usees-vidange': 'Huile usées (Vidange...)',
  'dechets-dangereux-materiaux-explosifs': 'Matériaux explosifs',
  'dechets-dangereux-peintures-et-vernis-usages': 'Peintures et Vernis usagés',
  'dechets-dangereux-piles-usagees': 'Piles usagées',
  'dechets-dangereux-produits-amiantiferes-toles-fibro-ciment': 'Produits amiantifères (tôles fibro-ciment)',
  'dechets-dangereux-produits-nettoyants-detergents-desinfectants': 'Produits nettoyants, détergents, désinfectants',
  'dechets-dangereux-produits-phytosanitaires-insecticides-herbicides-acaricides': 'Produits phytosanitaires (insecticides, herbicides, acaricides)',
  'dechets-dangereux-produits-radioactifs': 'Produits radioactifs',
  'dechets-dangereux-reste-d-engrais': "Reste d'engrais",
  'dechets-dangereux-solvants-decapants-alcools-cetones-ethers-esters': 'Solvants (décapants, alcools, cétones, ethers, esters)',
  'dechets-en-verre': 'Déchets en verre',
  'dechets-en-verre-bouteille-bocaux-flacons-pots-verre': 'Bouteille, bocaux, flacons, pots (verre)',
  'dechets-menagers': 'Déchets Ménagers',
  'dechets-menagers-articles-d-hygiene-couches-lingettes-mouchoirs': "Articles d'hygiène (couches, lingettes, mouchoirs…)",
  'dechets-menagers-petits-objets-casses-non-electriques': 'Petits objets cassés non-éléctriques',
  'dechets-menagers-vaisselle-et-assiettes-cassees': 'Vaisselle et assiettes cassées',
  'dechets-menagers-vaisselle-jetable': 'Vaisselle jetable',
  'dechets-papier': 'Déchets Papier',
  'dechets-papier-catalogue': 'Catalogue',
  'dechets-papier-enveloppes': 'Enveloppes',
  'dechets-papier-feuilles-dessin-cahier': 'Feuilles (dessin, cahier)',
  'dechets-papier-journaux-magazines': 'Journaux, magazines',
  'dechets-papier-livres-abimes': 'Livres abîmés',
  'dechets-papier-papier-cadeau': 'Papier cadeau',
  'dechets-papier-tickets-de-caisse': 'Tickets de caisse',
  'dechets-verts': 'Déchets Verts',
  'dechets-verts-branchage-et-bois': 'Branchage et bois',
  'dechets-verts-dechets-papier-divers': 'Déchets papier divers',
  'dechets-verts-dechets-verts-divers': 'Déchets verts divers',
  'dechets-verts-feuilles': 'Feuilles',
  'dechets-verts-taille': 'Taille',
  'dechets-verts-terre': 'Terre',
  'dechets-verts-tonte-de-pelouse': 'Tonte de Pelouse',
  'produits-medicaux': 'Produits Médicaux',
  'produits-medicaux-dechets-infectieux-des-soins-medicaux-ou-veterinaires': 'Déchets infectieux des soins médicaux ou vétérinaires',
  'produits-medicaux-emballages-de-medicaments': 'Emballages de médicaments',
  'produits-medicaux-produits-medicaux-divers': 'Produits médicaux divers',
  'produits-medicaux-reste-de-medicaments': 'Reste de médicaments',
  'produits-medicaux-seringues-usagees': 'Seringues usagées',
  'loisirs-et-jeux': 'Loisirs et jeux',
  'maison-decoration-et-arts-de-la-table': 'Maison, décoration et arts de la table',
  'materiel-specialise-et-professionnel': 'Matériel spécialisé et professionnel',
  meubles: 'Meubles',
  'sports-et-activites-de-plein-air': 'Sports et activités de plein air',
  'vehicules-pieces-et-accessoires': 'Véhicules, pièces et accessoires',
  'vetements-chaussures-et-accessoires': 'Vêtements, chaussures et accessoires',
  'accessoires-de-puericulture': 'Accessoires de puériculture',
  alimentation: 'Alimentation',
  animalerie: 'Animalerie',
  'bricolage-outillage-et-materiaux': 'Bricolage, outillage et matériaux',
  electromenager: 'Électroménager',
  'fourniture-de-bureau-et-papeterie': 'Fourniture de bureau et papeterie',
  'high-tech-et-electronique': 'High-tech et électronique',
  'jardin-et-exterieur': 'Jardin et extérieur',
  'hygiene-soins-et-beaute': 'Hygiène, soins et beauté',
  'livres-audio-films-et-billetterie': 'Livres, audio, films et billetterie',
};

export const checkIfOldCategoryMappedToNew = (oldCategory: string): oldCategory is CategoryMappingKey => Object.hasOwn(categoryMapping, oldCategory);

export const checkIfOldCategoryShouldRedirectToNewCategory = (oldCategoryMapped: number): oldCategoryMapped is NewCategoryMappingKey => Object.hasOwn(newCategoryMapping, oldCategoryMapped);
